<template>
  <section class="case-creation" v-loading="loading">
    <div class="container-sm">
      <!-- Creation start here -->
      <!-- Patient information start here -->
      <div class="case-creation__step case-creation__patient-information">
        <el-row gutter="15">
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading each-item-creation">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-patient-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Patient Information</h3>
                </div>
              </div>
              <PatientInformation
                v-if="showDob"
                :patientInfo="patientInformation"
                @changeValues="updateData"
                @updateInsurance="updatePatientData"
                ref="patientInformationForm"
              ></PatientInformation>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- Patient information end here -->

      <span class="case-creation__divider"></span>
      <!-- Case information start here -->
      <div class="case-creation__step case-creation__patient-information">
        <el-row gutter="20">
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-case-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Case Information</h3>
                </div>
              </div>
              <div class="case-creation__body pb-0">
                <div class="vue-form">
                  <el-form :model="caseInformation">
                    <el-row :gutter="15">
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Case type
                              <span class="star">*</span>
                            </label>
                            <el-select
                              filterable
                              multiple
                              v-model="caseInformation.case_types"
                              @change="addSpecimenCaseTypes"
                              placeholder="Select Case type"
                              collapse-tags
                              :multiple-limit="getCaseTypeLimit"
                              disabled
                            >
                              <el-option
                                v-for="(caseType, index) of getCaseTypes"
                                :key="index"
                                :value="caseType.value"
                                :label="caseType.case_name"
                                :disabled="checkCaseTypeDisable(caseType)"
                              ></el-option>
                            </el-select>
                            <p class="err error-break">
                              <FormError errorName="case_types"></FormError>
                            </p>
                            <div
                              class="case-select-types"
                              :class="{
                                'active-case-type-error': isError,
                              }"
                            >
                              <p
                                class="selected-case-types"
                                v-for="(
                                  caseTypeVal, index
                                ) in caseInformation.case_types"
                                :key="index"
                              >
                                {{ caseTypeMap[caseTypeVal] }}
                                <span
                                  class="test-close"
                                  v-if="!this.$route.params.phlebio_id"
                                >
                                  <el-icon @click="remove(index)">
                                    <circle-close-filled />
                                  </el-icon>
                                </span>
                              </p>
                            </div>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div
                          class="case-creation__input"
                          v-if="hadBloodCaseType"
                        >
                          <el-form-item>
                            <label for="text">
                              Ordering Facility
                              <span class="star">*</span>
                            </label>
                            <el-select
                              v-model="caseInformation.hospital"
                              placeholder="Select Ordering Facility"
                              @change="fetchAllPhysiciansByHospital"
                              default-first-option
                              :reserve-keyword="false"
                              clearable
                              filterable
                              @focus="fetchHospitalsData"
                              :loading="hospitalsLoading"
                            >
                              <el-option
                                v-for="(hospital, index) of labdaqFacilityData"
                                :key="index"
                                :value="hospital._id"
                                :label="hospital.name"
                                :disabled="isInactiveStatus(hospital)"
                              >
                                <span style="float: left">{{
                                  hospital.name
                                }}</span>
                                <span
                                  v-if="isInactiveStatus(hospital)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 10px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="hospital"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                        <div class="case-creation__input" v-else>
                          <el-form-item>
                            <label for="text">
                              Ordering Facility
                              <span class="star">*</span>
                            </label>
                            <el-select
                              v-model="caseInformation.hospital"
                              placeholder="Select Ordering Facility"
                              @change="fetchAllPhysiciansByHospital"
                              clearable
                              filterable
                              default-first-option
                              :loading="hospitalsLoading"
                              @focus="fetchHospitalsData"
                            >
                              <el-option
                                v-for="(hospital, index) of hospitalsData.data"
                                :key="index"
                                :value="hospital._id"
                                :label="hospital.name"
                                :disabled="isInactiveStatus(hospital)"
                              >
                                <span style="float: left">
                                  {{ hospital.name }}
                                </span>
                                <span
                                  v-if="isInactiveStatus(hospital)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 10px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="hospital"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Ordering Facility Branch</label>
                            <el-select
                              placeholder="Select Ordering Facility Branch"
                              @change="fetchAllPhysiciansByHospitalBranch"
                              v-model="caseInformation.hospital_branch"
                              clearable
                              filterable
                              default-first-option
                            >
                              <el-option
                                v-for="(hospital, index) of hospitalBranches"
                                :key="index"
                                :value="hospital._id"
                                :label="hospital.display_name"
                                :disabled="isInactiveStatus(hospital)"
                              >
                                <span style="float: left">
                                  {{ hospital.display_name }}
                                </span>
                                <span
                                  v-if="isInactiveStatus(hospital)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 10px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="facility_branch"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Ordering Physician
                              <span class="star">*</span>
                            </label>
                            <el-select
                              placeholder="Select Ordering Physician"
                              v-model="caseInformation.ordering_physician"
                              clearable
                              filterable
                              default-first-option
                              @change="checkPhysicianPecos"
                            >
                              <el-option
                                v-for="physician in physiciansData.data"
                                :key="physician._id"
                                :label="physician.name"
                                :value="physician._id"
                                :disabled="isInactiveStatus(physician)"
                              >
                                <span style="float: left">
                                  {{ physician.name }}
                                </span>
                                <span
                                  v-if="isInactiveStatus(physician)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 15px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="ordering_physician"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Referring Physician</label>
                            <el-select
                              v-model="caseInformation.referring_physician"
                              placeholder="Select Referring Physician"
                              clearable
                              filterable
                              :loading="physicianLoading"
                              @focus="fetchPhysiciansData"
                              default-first-option
                            >
                              <el-option
                                v-for="physician in allReferringPhysicians"
                                :key="physician._id"
                                :label="physician.name"
                                :value="physician._id"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="referring_physician"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Bill To
                              <span class="star">*</span>
                            </label>
                            <el-select
                              placeholder="Select Bill To"
                              clearable
                              filterable
                              default-first-option
                              v-model="caseInformation.billing_type"
                            >
                              <el-option
                                class="referring-physician-options"
                                label="INSURANCE"
                                value="INSURANCE"
                              ></el-option>
                              <el-option
                                label="PATIENT"
                                value="PATIENT"
                              ></el-option>
                              <el-option
                                label="CLIENT"
                                value="CLIENT"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="billing_type"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Order Id</label>
                            <el-input
                              type="text"
                              placeholder="Enter Order Id"
                              v-model="caseInformation.order_id"
                              :rows="3"
                              :disabled="this.$route.params.phlebio_id"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="order_id"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="16" :lg="16" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              ICD-10 ( Indicative )
                              <span class="star">*</span>
                            </label>

                            <div class="ten-icd-group d-flex">
                              <div
                                class="each-input mr-5"
                                v-for="(
                                  icdCode, index
                                ) of caseInformation.icd_10_codesForm"
                                :key="index"
                              >
                                <el-autocomplete
                                  placeholder="CODE"
                                  v-model="icdCode.value"
                                  popper-class="ten-icd-popper"
                                  :fetch-suggestions="getAutoCompleteICDData"
                                  @select="selectICDCode($event, icdCode)"
                                >
                                  <template #default="{ item }">
                                    <div class="icd-dropdown-style">
                                      <span class="code pr-5">
                                        {{ item.code }}
                                      </span>
                                      <span class="desc pl-5">
                                        {{ item.description }}
                                      </span>
                                    </div>
                                  </template>
                                </el-autocomplete>
                              </div>
                            </div>
                            <p class="err">
                              <FormError errorName="icd_10_codes"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Collection Date & Time
                              <span class="star">*</span>
                            </label>
                            <el-date-picker
                              type="datetime"
                              v-model="caseInformation.collection_date"
                              placeholder="MM-DD-YYYY HH:MM AM"
                              format="MM-DD-YYYY hh:mm A"
                              :disabled-date="disabledDate"
                              :default-time="defaultTime"
                            ></el-date-picker>
                            <p class="err">
                              <FormError
                                errorName="collection_date"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Received Date & Time
                              <span class="star">*</span>
                            </label>
                            <el-date-picker
                              type="datetime"
                              v-model="caseInformation.received_date"
                              placeholder="MM-DD-YYYY HH:MM AM"
                              format="MM-DD-YYYY hh:mm A"
                              :disabled-date="disabledDate"
                              :default-time="defaultTime"
                            ></el-date-picker>
                            <p class="err">
                              <FormError errorName="received_date"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Temperature</label>
                            <el-input
                              type="text"
                              placeholder="Enter Temperature"
                              v-model="caseInformation.temperature"
                              :rows="3"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="temperature"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col
                        :xl="3"
                        :lg="3"
                        :md="3"
                        :sm="6"
                        :xs="6"
                        v-if="
                          hadBloodCaseType &&
                          hasPermission(
                            'test_reports',
                            'update_download_status'
                          )
                        "
                      >
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text"
                              >Fasting
                              <span class="star">*</span>
                            </label>
                            <el-select
                              v-model="caseInformation.is_fasting"
                              clearable
                            >
                              <el-option
                                v-for="item in fastingOptions"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label"
                              >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="is_fasting"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col
                        :xl="8"
                        :lg="10"
                        :md="3"
                        :sm="6"
                        :xs="6"
                        v-if="
                          caseInformation.case_types &&
                          caseInformation.case_types.length == 1
                        "
                      >
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Specimen Types
                              <span class="star">*</span>
                            </label>
                            <div
                              class="specimen-case-type"
                              v-for="(type, index) in this.caseInformation
                                .sample_types"
                              :key="index"
                            >
                              <span class="case-name">
                                {{ caseTypeMap[type.case_type] }}
                              </span>
                              <span class="custom-select-capitalize">
                                <el-select
                                  v-model="type.sample_types"
                                  multiple
                                  filterable
                                  :reserve-keyword="false"
                                  default-first-option
                                  popper-class="custom-select-dropdown"
                                  @change="setShowChecklist(type.sample_types)"
                                >
                                  <el-option
                                    v-for="(
                                      specimen, index
                                    ) in getSpecimenTypes[type.case_type]"
                                    :key="index"
                                    :label="specimen"
                                    :value="specimen"
                                  ></el-option>
                                </el-select>
                                <p class="err">
                                  <FormError
                                    :errorName="`sample_types.${index}.sample_types`"
                                  ></FormError>
                                </p>
                              </span>
                            </div>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- Case information end here -->
      <span class="case-creation__divider" v-if="isToxicCaseType"></span>
      <div
        class="case-creation__step case-creation__patient-information"
        v-if="isToxicCaseType && (this.showOralChecklist || this.showChekclist)"
      >
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Toxicology Orders Checklist</h3>
            </div>
          </div>
          <div class="case-creation__body">
            <div
              v-if="showChekclist"
              class="case-creation__toxicology-checklist"
            >
              <div class="checkbox-order">
                <el-checkbox-group
                  v-model="toxicology_ereq_form"
                  class="search-checkbox checklist-grid"
                >
                  <el-checkbox
                    v-for="option in availableOptions"
                    :key="option.label"
                    :label="option.label"
                    :disabled="option.disabled"
                    @change="updateCheckedOptions(option.label, $event)"
                  />
                </el-checkbox-group>
              </div>
            </div>
            <div
              v-if="showOralChecklist"
              class="case-creation__toxicology-checklist"
            >
              <div class="checkbox-order">
                <el-checkbox
                  v-model="toxicology_ereq_form"
                  class="search-checkbox"
                  label="Confirm Tests Selected Below"
                >
                </el-checkbox>
              </div>
            </div>
            <div
              v-if="
                this.getValidationErrors &&
                this.getValidationErrors.error_code &&
                this.getValidationErrors.error_code == 'SELECT_ANY_ONE_OPTION'
              "
            >
              <p class="err">
                <FormError errorName="toxicology_ereq_form"></FormError>
              </p>
            </div>
          </div>
        </div>
      </div>
      <span class="case-creation__divider" v-if="isToxicCaseType"></span>

      <span class="case-creation__divider"></span>
      <!-- Test information start here -->
      <div class="case-creation__step case-creation__test-information">
        <div class="case-creation__card">
          <div class="text-information-card">
            <div class="case-creation__heading border-bottom-none">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-test-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Test Information</h3>
              </div>
            </div>
            <div class="test-information-header">
              <p>You can manage tests here, please add to start swathi</p>

              <div>
                <div>
                  <el-button
                    type="text"
                    class="btn radius-button add-test-btn"
                    @click="popupScreen"
                    disabled
                  >
                    <span>
                      <img
                        src="@/assets/images/icons/cases/add-test.svg"
                        alt="tests-icon"
                      />
                    </span>
                    ADD TESTS
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="selected-tests-information"
        v-if="
          panelsTestsData.selectedTestIds &&
          panelsTestsData.selectedTestIds.length > 0 &&
          !addtestModelPopup &&
          !hideTestsDetails
        "
      >
        <div class="each-test-information">
          <el-checkbox-group
            v-model="panelsTestsData.selectedTestIds"
            class="case-vue-tabs vue-tabs"
          >
            <el-tabs v-if="!addtestModelPopup">
              <el-tab-pane
                v-for="(test, index) of getSelectedCaseTypes()"
                :key="index"
              >
                <template #label>
                  <h3 class="selected-test-title">
                    {{ index + 1 }}. {{ caseTypeMap[test.case_type_code] }}
                  </h3>
                </template>
                <div v-if="test.case_type_code == 'TOXICOLOGY'">
                  <ToxicologyTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></ToxicologyTestsPreview>
                </div>
                <div v-else-if="test.case_type_code == 'WOUND'">
                  <WoundPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></WoundPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'NAIL'">
                  <NailPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></NailPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'GASTRO'">
                  <GastroPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></GastroPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'UTI'">
                  <UTIPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></UTIPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'CLINICAL_CHEMISTRY'">
                  <BloodPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></BloodPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'STI'">
                  <GTIWomensHealthTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></GTIWomensHealthTests>
                </div>
                <div v-else-if="test.case_type_code == 'URINALYSIS'">
                  <UrinalysisTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></UrinalysisTestsPreview>
                </div>
                <div v-else>
                  <DefaultPanelSelectedTests
                    v-if="show"
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :testType="test"
                    :allSelectedTests="allTests"
                    :caseType="test.case_type_code"
                  ></DefaultPanelSelectedTests>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-checkbox-group>
        </div>
      </div>
      <div class="center-error-message" v-if="isTestInfoError">
        <p class="err">
          <FormError errorName="tests_info"></FormError>
        </p>
      </div>
      <!-- Test information end here -->
      <div class="case-creation__add-test" v-if="addtestModelPopup">
        <div class="add-test-popup">
          <el-dialog
            width="90%"
            v-model="addtestModelPopup"
            :destroy-on-close="true"
          >
            <AddTests
              :panelsTestsDataUnchanged="panelsTestsData"
              :caseTypes="caseInformation.case_types"
              @addTestsData="updateTestsPanelsData"
              :customProfile="custom_test_profiles"
              :selectedChecklist="toxicology_ereq_form"
              :selectedSample="selectedSpecimen"
              v-if="addtestModelPopup"
            ></AddTests>
          </el-dialog>
        </div>
      </div>
      <span class="case-creation__divider"></span>

      <div
        class="case-creation__step case-creation"
        v-if="hasPermission('test_reports', 'update_download_status')"
      >
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-billing-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Additional Notes</h3>
            </div>
          </div>
          <div class="case-creation__body">
            <div class="billing-information-tabs">
              <el-row :gutter="15">
                <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                  <div class="case-creation__input billing_notes">
                    <label for="text"> Additional Notes </label>
                    <el-input
                      v-model="physician_notes"
                      type="textarea"
                      placeholder="Enter Additional Notes"
                    ></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div
        class="case-creation__step case-creation__patient-information signature-settings"
        v-if="isFacilityUser"
      >
        <el-row gutter="20">
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-case-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">E-REQ-Signature Settings</h3>
                </div>
              </div>
              <div class="case-creation__body pb-0">
                <div class="vue-form uti-medical-necessity">
                  <el-form :model="signatureInformation">
                    <el-row :gutter="15">
                      <el-col :span="8">
                        <div
                          class="signature-after-sign"
                          v-if="
                            patient_sign &&
                            !signatureInformation.patient_signature
                          "
                        >
                          <img :src="patient_sign" />
                        </div>
                        <div>
                          <div
                            class="undo-clear-btn"
                            v-if="patient_sign"
                            @click="clearPatientSign"
                          >
                            Clear
                          </div>
                          <div
                            class="cursor"
                            @click="openPatientSignatureSettings"
                            v-if="!signatureInformation.patient_signature"
                          >
                            {{ this.patient_sign ? "Update" : "Add" }} Patient
                            Signature
                            <el-icon>
                              <EditPen />
                            </el-icon>
                          </div>
                        </div>
                        <p class="err">
                          <FormError
                            errorName="signature_settings.patient_sign"
                          ></FormError>
                        </p>
                      </el-col>
                      <el-col :span="8">
                        <div
                          class="signature-after-sign"
                          v-if="
                            physician_sign &&
                            !signatureInformation.physician_signature
                          "
                        >
                          <img :src="physician_sign" />
                        </div>
                        <div>
                          <div
                            class="undo-clear-btn"
                            v-if="physician_sign"
                            @click="clearPhysicinaSign"
                          >
                            Clear
                          </div>
                          <div
                            class="cursor"
                            @click="openPhysicianSignatureSettings"
                            v-if="!signatureInformation.physician_signature"
                          >
                            {{ this.physician_sign ? "Update" : "Add" }}
                            Ordering Physician Signature
                            <el-icon>
                              <EditPen />
                            </el-icon>
                          </div>
                        </div>
                        <p class="err">
                          <FormError
                            errorName="signature_settings.physician_sign"
                          ></FormError>
                        </p>
                      </el-col>
                      <el-col :span="8">
                        <div
                          class="signature-after-sign"
                          v-if="
                            guardian_sign &&
                            !signatureInformation.guardian_signature
                          "
                        >
                          <img :src="guardian_sign" />
                        </div>
                        <div>
                          <div
                            class="undo-clear-btn"
                            v-if="guardian_sign"
                            @click="clearGuardianSign"
                          >
                            Clear
                          </div>
                          <div
                            class="cursor"
                            @click="openGuardianSignatureSettings"
                            v-if="!signatureInformation.guardian_signature"
                          >
                            {{ this.guardian_sign ? "Update" : "Add" }}
                            Parent/Guardian Signature
                            <el-icon>
                              <EditPen />
                            </el-icon>
                          </div>
                        </div>
                        <p class="err">
                          <FormError
                            errorName="signature_settings.guardian_sign"
                          ></FormError>
                        </p>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span class="case-creation__divider"></span>
      <!-- Medications start here -->
      <div class="case-creation__step case-creation__test-information">
        <MedicationsAdd
          v-if="showMedication"
          :medicationsData="medicationsList"
          ref="medicationFormDetails"
          :newCase="checkCaseValidation"
        ></MedicationsAdd>
        <div class="center-error-message" v-if="isMedicationError">
          <p class="err">
            <FormError errorName="medication"></FormError>
          </p>
        </div>
      </div>
      <!-- Medications end here -->

      <!-- Medical Necessity starts here -->
      <div
        class="case-creation__step case-creation__patient-information medical-necessity-step"
        v-if="isAbleToAdd && hadCaseType"
      >
        <el-row gutter="15">
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-patient-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Medical Necessity</h3>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadToxicCaseType"
              >
                <div class="heading-block mb-20">
                  <h3>Toxicology Order Medical Necessity</h3>
                </div>
                <div class="vue-form">
                  <el-form :model="toxicologyOrderInformation">
                    <el-row :gutter="15">
                      <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Patient Name
                              <span class="star">*</span>
                            </label>

                            <el-input
                              readonly
                              v-model="toxicologyOrderInformation.patient_name"
                              placeholder="Enter Patient Name"
                              class="el-input"
                            ></el-input>
                            <p class="err">
                              <FormError
                                errorName="toxicology_order_medical_necessity_fields.patient_name"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="5" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Patient DOB
                              <span class="star">*</span>
                            </label>

                            <el-date-picker
                              format="MM-DD-YYYY"
                              v-model="toxicologyOrderInformation.patient_dob"
                              :disabled-date="disabledDate"
                              placeholder="MM-DD-YYYY"
                              :clearable="true"
                              readonly
                            ></el-date-picker>
                            <p class="err">
                              <FormError
                                errorName="toxicology_order_medical_necessity_fields.patient_dob"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Date of Service
                              <span class="star">*</span>
                            </label>
                            <el-date-picker
                              type="date"
                              v-model="
                                toxicologyOrderInformation.date_of_service
                              "
                              placeholder="MM-DD-YYYY"
                              format="MM-DD-YYYY"
                              :editable="false"
                              :disabled-date="disabledDate"
                            ></el-date-picker>
                            <p class="err">
                              <FormError
                                errorName="toxicology_order_medical_necessity_fields.date_of_service"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <div class="vue-form">
                      <el-form-item>
                        <span>
                          I
                          <input
                            style="
                              width: 300px;
                              border: none;
                              outline: none;
                              border-bottom: 1px solid #000000;
                            "
                            v-model="toxicologyOrderInformation.provider_name"
                            placeholder="Enter Provider Name"
                          />
                          writing an order for a Toxiclogy test for this patient
                          for the following reason(S) marked. This order will
                          remain in effect for the
                          <br />next twelve (12) months and/or while under my
                          care.
                        </span>
                        <p class="err">
                          <FormError
                            errorName="toxicology_order_medical_necessity_fields.provider_name"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                    <div>
                      <el-form-item>
                        <el-checkbox-group
                          v-model="toxicologyOrderInformation.check_list"
                        >
                          <el-checkbox
                            label="New Patient to establish a baseline."
                          />
                          <br />

                          <el-checkbox
                            label="Patient Who is on chronic controlled medication(s)."
                          />
                          <br />
                          <el-checkbox
                            label="Patient with a history of substance abuse."
                          />
                          <br />
                          <el-checkbox
                            label="Patient requesting refill on any controlled medication."
                          />
                          <br />
                          <el-checkbox
                            label="Patient undergoing surgery-to ensure no abuse or elicits or controlled medications that may have adverse effects on anesthesia and surgery."
                          />
                          <br />
                          <el-checkbox
                            label="The patient is suspected of abusing and/or diverting with current medication(s)."
                          />
                          <br />
                          <el-checkbox
                            label="Other diagnostic or medical reasons not noted above."
                          />
                        </el-checkbox-group>
                      </el-form-item>
                    </div>
                    <div class="other mt-20">
                      <el-row>
                        <el-col :xl="14" :lg="16" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">Please explain :</label>
                              <el-input
                                v-model="
                                  toxicologyOrderInformation.please_explain
                                "
                                type="textarea"
                                placeholder="Enter Text"
                              />
                            </el-form-item>
                          </div>
                          <div class="text-block mb-20">
                            <h4>
                              I certify that the testing referenced above is
                              medically necessary. I intend to utilize the test
                              results to inform my treatment decision as
                              indicated in the application section above.
                            </h4>
                            <div style="height: 40px"></div>
                            <p>Best Regards,</p>
                          </div>
                        </el-col>
                      </el-row>

                      <el-row :gutter="15">
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Name of Practice
                                <span class="star">*</span>
                              </label>
                              <el-input
                                readonly
                                v-model="
                                  toxicologyOrderInformation.name_of_practice
                                "
                                placeholder="Enter Name of Practice"
                                class="el-input"
                              ></el-input>

                              <p class="err">
                                <FormError
                                  errorName="toxicology_order_medical_necessity_fields.name_of_practice"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Name of Physician
                                <span class="star">*</span>
                              </label>
                              <el-input
                                readonly
                                placeholder="Enter Name of Physician"
                                v-model="
                                  toxicologyOrderInformation.name_of_clinician
                                "
                              ></el-input>

                              <p class="err">
                                <FormError
                                  errorName="toxicology_order_medical_necessity_fields.name_of_clinician"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Physician NPI
                                <span class="star">*</span>
                              </label>

                              <el-input
                                readonly
                                v-model="
                                  toxicologyOrderInformation.clinician_npi
                                "
                                placeholder="Enter NPI"
                                class="el-input"
                                maxlength="10"
                              ></el-input>
                              <p class="err">
                                <FormError
                                  errorName="toxicology_order_medical_necessity_fields.clinician_npi"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text"
                                >Ordering Physician Signature</label
                              >

                              <el-input
                                v-model="
                                  toxicologyOrderInformation.ordering_clinician_signature
                                "
                                placeholder="Enter Signature"
                                class="el-input"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Date
                                <span class="star">*</span>
                              </label>
                              <el-date-picker
                                type="date"
                                v-model="toxicologyOrderInformation.date"
                                placeholder="MM-DD-YYYY"
                                format="MM-DD-YYYY"
                                :editable="false"
                                :disabled-date="disabledDate"
                              ></el-date-picker>
                              <p class="err">
                                <FormError
                                  errorName="toxicology_order_medical_necessity_fields.date"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-form>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadUrinalysisCaseType"
              >
                <div class="heading-block mb-20">
                  <h3>Urinalysis Order Medical Necessity</h3>
                </div>
                <div class="vue-form">
                  <el-form :model="urinalysisOrderInformation">
                    <el-row :gutter="15">
                      <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Patient Name
                              <span class="star">*</span>
                            </label>

                            <el-input
                              readonly
                              v-model="urinalysisOrderInformation.patient_name"
                              placeholder="Enter Patient Name"
                              class="el-input"
                            ></el-input>
                            <p class="err">
                              <FormError
                                errorName="urinalysis_order_medical_necessity_fields.patient_name"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="5" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Patient DOB
                              <span class="star">*</span>
                            </label>

                            <el-date-picker
                              format="MM-DD-YYYY"
                              v-model="urinalysisOrderInformation.patient_dob"
                              :disabled-date="disabledDate"
                              placeholder="MM-DD-YYYY"
                              :clearable="true"
                              readonly
                            ></el-date-picker>
                            <p class="err">
                              <FormError
                                errorName="urinalysis_order_medical_necessity_fields.patient_dob"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Date of Service
                              <span class="star">*</span>
                            </label>
                            <el-date-picker
                              type="date"
                              v-model="
                                urinalysisOrderInformation.date_of_service
                              "
                              placeholder="MM-DD-YYYY"
                              format="MM-DD-YYYY"
                              :editable="false"
                              :disabled-date="disabledDate"
                            ></el-date-picker>
                            <p class="err">
                              <FormError
                                errorName="urinalysis_order_medical_necessity_fields.date_of_service"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                    <div class="vue-form">
                      <el-form-item>
                        <span>
                          I
                          <input
                            style="
                              width: 300px;
                              border: none;
                              outline: none;
                              border-bottom: 1px solid #000000;
                            "
                            v-model="urinalysisOrderInformation.provider_name"
                            placeholder="Enter Provider Name"
                          />
                          writing an order for a Toxiclogy test for this patient
                          for the following reason(S) marked. This order will
                          remain in effect for the
                          <br />next twelve (12) months and/or while under my
                          care.
                        </span>
                        <p class="err">
                          <FormError
                            errorName="urinalysis_order_medical_necessity_fields.provider_name"
                          ></FormError>
                        </p>
                      </el-form-item>
                    </div>
                    <div>
                      <el-form-item>
                        <el-checkbox-group
                          v-model="urinalysisOrderInformation.check_list"
                        >
                          <el-checkbox
                            label="New Patient to establish a baseline."
                          />
                          <br />

                          <el-checkbox
                            label="Patient Who is on chronic controlled medication(s)."
                          />
                          <br />
                          <el-checkbox
                            label="Patient with a history of substance abuse."
                          />
                          <br />
                          <el-checkbox
                            label="Patient requesting refill on any controlled medication."
                          />
                          <br />
                          <el-checkbox
                            label="Patient undergoing surgery-to ensure no abuse or elicits or controlled medications that may have adverse effects on anesthesia and surgery."
                          />
                          <br />
                          <el-checkbox
                            label="The patient is suspected of abusing and/or diverting with current medication(s)."
                          />
                          <br />
                          <el-checkbox
                            label="Other diagnostic or medical reasons not noted above."
                          />
                        </el-checkbox-group>
                      </el-form-item>
                    </div>
                    <div class="other mt-20">
                      <el-row>
                        <el-col :xl="14" :lg="16" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">Please explain :</label>
                              <el-input
                                v-model="
                                  urinalysisOrderInformation.please_explain
                                "
                                type="textarea"
                                placeholder="Enter Text"
                              />
                            </el-form-item>
                          </div>
                          <div class="text-block mb-20">
                            <h4>
                              I certify that the testing referenced above is
                              medically necessary. I intend to utilize the test
                              results to inform my treatment decision as
                              indicated in the application section above.
                            </h4>
                            <div style="height: 40px"></div>
                            <p>Best Regards,</p>
                          </div>
                        </el-col>
                      </el-row>

                      <el-row :gutter="15">
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Name of Practice
                                <span class="star">*</span>
                              </label>
                              <el-input
                                readonly
                                v-model="
                                  urinalysisOrderInformation.name_of_practice
                                "
                                placeholder="Enter Name of Practice"
                                class="el-input"
                              ></el-input>

                              <p class="err">
                                <FormError
                                  errorName="urinalysis_order_medical_necessity_fields.name_of_practice"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Name of Physician
                                <span class="star">*</span>
                              </label>
                              <el-input
                                readonly
                                placeholder="Enter Name of Physician"
                                v-model="
                                  urinalysisOrderInformation.name_of_clinician
                                "
                              ></el-input>

                              <p class="err">
                                <FormError
                                  errorName="urinalysis_order_medical_necessity_fields.name_of_clinician"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Physician NPI
                                <span class="star">*</span>
                              </label>

                              <el-input
                                readonly
                                v-model="
                                  urinalysisOrderInformation.clinician_npi
                                "
                                placeholder="Enter NPI"
                                class="el-input"
                                maxlength="10"
                              ></el-input>
                              <p class="err">
                                <FormError
                                  errorName="urinalysis_order_medical_necessity_fields.clinician_npi"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text"
                                >Ordering Physician Signature</label
                              >

                              <el-input
                                v-model="
                                  urinalysisOrderInformation.ordering_clinician_signature
                                "
                                placeholder="Enter Signature"
                                class="el-input"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Date
                                <span class="star">*</span>
                              </label>
                              <el-date-picker
                                type="date"
                                v-model="urinalysisOrderInformation.date"
                                placeholder="MM-DD-YYYY"
                                format="MM-DD-YYYY"
                                :editable="false"
                                :disabled-date="disabledDate"
                              ></el-date-picker>
                              <p class="err">
                                <FormError
                                  errorName="urinalysis_order_medical_necessity_fields.date"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-form>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadUTICaseType"
              >
                <div class="heading-block">
                  <h3>Urinary Tract Infection Medical Necessity</h3>
                  <p>Dear Provider,</p>
                </div>
                <div class="text-block">
                  <p class="mb-30">
                    Since indicated that you wish to order a Urinary Tract
                    Infection Panel OR you have requested a urinalysis to reflex
                    to the UTI Panel if anything is positive, please complete
                    the Medical Necessity Letter below. Please do not use a
                    stamped signature on this form.
                  </p>
                  <div class="vue-form">
                    <el-form :model="utiOrderInformation">
                      <el-row :gutter="15">
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Patient Name
                                <span class="star">*</span>
                              </label>

                              <el-input
                                readonly
                                v-model="utiOrderInformation.patient_name"
                                placeholder="Enter Patient Name"
                                class="el-input"
                              ></el-input>
                              <p class="err">
                                <FormError
                                  errorName="urinary_tract_infectious_medical_necessity_fields.patient_name"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="5" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Patient DOB
                                <span class="star">*</span>
                              </label>

                              <el-date-picker
                                format="MM-DD-YYYY"
                                v-model="utiOrderInformation.patient_dob"
                                :disabled-date="disabledDate"
                                placeholder="MM-DD-YYYY"
                                :clearable="true"
                                readonly
                              ></el-date-picker>
                              <p class="err">
                                <FormError
                                  errorName="urinary_tract_infectious_medical_necessity_fields.patient_dob"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">
                                Date of Service
                                <span class="star">*</span>
                              </label>
                              <el-date-picker
                                type="date"
                                v-model="utiOrderInformation.date_of_service"
                                placeholder="MM-DD-YYYY"
                                format="MM-DD-YYYY"
                                :editable="false"
                                :disabled-date="disabledDate"
                              ></el-date-picker>
                              <p class="err">
                                <FormError
                                  errorName="urinary_tract_infectious_medical_necessity_fields.date_of_service"
                                ></FormError>
                              </p>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :xl="16" :lg="16" :md="3" :sm="6" :xs="6">
                          <div class="case-creation__input">
                            <el-form-item>
                              <label for="text">ICD-10 ( Indicative )</label>
                              <div class="ten-icd-group d-flex">
                                <div
                                  class="each-input mr-5"
                                  v-for="(
                                    icdCode, index
                                  ) of caseInformation.icd_10_codesForm"
                                  :key="index"
                                >
                                  <el-autocomplete
                                    placeholder="CODE"
                                    v-model="icdCode.value"
                                    popper-class="ten-icd-popper"
                                    :fetch-suggestions="getAutoCompleteICDData"
                                    @select="selectICDCode($event, icdCode)"
                                    disabled
                                  >
                                    <template #default="{ item }">
                                      <div class="icd-dropdown-style">
                                        <span class="code pr-5">
                                          {{ item.code }}
                                        </span>
                                        <span class="desc pl-5">
                                          {{ item.description }}
                                        </span>
                                      </div>
                                    </template>
                                  </el-autocomplete>
                                </div>
                              </div>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-row>
                      <div class="heading-block mt-10 mb-20">
                        <h3>Dear Claims Specialist:</h3>
                        <p>
                          Please consider this letter of Medical Necessity a
                          formal request for full coverage of the Urinary Tract
                          Infection Panel testing services that I intend to
                          prescribe for your subscriber (Patient Name Listed
                          Above. The results will assist me in making
                          patient-specific clinical decisions regarding the
                          medical management of your subscriber.
                        </p>
                        <p>
                          To provide the safest, most effective, and most
                          affordable medical care possible, the requested
                          molecular testing is medically necessary for my
                          patient for the following reason(s):
                        </p>
                      </div>
                      <div>
                        <el-form-item>
                          <el-checkbox-group
                            v-model="utiOrderInformation.check_list"
                          >
                            <el-checkbox
                              label="Patient presents with urinary tract discomfort or UTI common symptoms"
                            />
                            <br />

                            <el-checkbox
                              label="Patient has a history of UTIs, and I would like to determine whether it is a bacterial or fungal infection"
                            />
                            <br />
                            <el-checkbox
                              label="I have ordered a urinalysis to determine if symptoms are from a UTI, if anything is positive, I would like to reflex to a UTI panel"
                            />
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="others mt-30">
                        <el-row>
                          <el-col :xl="12" :lg="16" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">Others :</label>
                                <el-input
                                  v-model="utiOrderInformation.others"
                                  type="textarea"
                                  placeholder="Enter Text"
                                />
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <div class="text-block mb-20">
                          <h4>
                            Because of this, the Urinary Tract Infection Panel
                            will help me to determine what bacterial or fungal
                            illnesses to treat
                          </h4>
                          <div style="height: 40px"></div>

                          <p>Best Regards,</p>
                        </div>

                        <el-row :gutter="15">
                          <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">
                                  Name of Practice
                                  <span class="star">*</span>
                                </label>
                                <el-input
                                  readonly
                                  v-model="utiOrderInformation.name_of_practice"
                                  placeholder="Enter Name of Practice"
                                  class="el-input"
                                ></el-input>

                                <p class="err">
                                  <FormError
                                    errorName="urinary_tract_infectious_medical_necessity_fields.name_of_practice"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">
                                  Name of Physician
                                  <span class="star">*</span>
                                </label>
                                <el-input
                                  readonly
                                  placeholder="Enter Name of Physician"
                                  v-model="
                                    utiOrderInformation.name_of_clinician
                                  "
                                ></el-input>

                                <p class="err">
                                  <FormError
                                    errorName="urinary_tract_infectious_medical_necessity_fields.name_of_clinician"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">
                                  Physician NPI
                                  <span class="star">*</span>
                                </label>

                                <el-input
                                  readonly
                                  v-model="utiOrderInformation.clinician_npi"
                                  placeholder="Enter NPI"
                                  class="el-input"
                                  maxlength="10"
                                ></el-input>
                                <p class="err">
                                  <FormError
                                    errorName="urinary_tract_infectious_medical_necessity_fields.clinician_npi"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text"
                                  >Ordering Physician Signature</label
                                >

                                <el-input
                                  v-model="
                                    utiOrderInformation.ordering_clinician_signature
                                  "
                                  placeholder="Enter Signature"
                                  class="el-input"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">
                                  Date
                                  <span class="star">*</span>
                                </label>
                                <el-date-picker
                                  type="date"
                                  v-model="utiOrderInformation.date"
                                  placeholder="MM-DD-YYYY"
                                  format="MM-DD-YYYY"
                                  :editable="false"
                                  :disabled-date="disabledDate"
                                ></el-date-picker>
                                <p class="err">
                                  <FormError
                                    errorName="urinary_tract_infectious_medical_necessity_fields.date"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadGastroCaseType"
              >
                <div class="heading-block">
                  <h3>Gastrointestinal Infection Panel Medical Necessity</h3>
                </div>
                <div class="text-block">
                  <p class="mb-30">
                    Since indicated that you wish to order a gastrointestinal
                    infection panel, please complete the medical necessity
                    letter below. Please do not use a stamped signature on this
                    form.
                  </p>
                  <div class="vue-form">
                    <el-form :model="gastroOrderInformation">
                      <div class="heading-block mt-10 mb-20">
                        <h3>Dear Claims Specialist:</h3>
                        <p>
                          Please consider this letter of medical necessity as a
                          formal request for full coverage of the
                          gastrointestinal infection panel testing services that
                          I intend to prescribe for your subscriber (Patient
                          Name Listed Above. The results will assist me in
                          making patient specific clinical decisions regarding
                          the medical management of your subscriber.
                        </p>
                        <p>
                          To provide the safest, most effective, and affordable
                          medical care possible, the requested molecular testing
                          is medically necessary for my patient for the
                          following reason(s):
                        </p>
                      </div>
                      <div>
                        <el-form-item>
                          <el-checkbox-group
                            v-model="gastroOrderInformation.check_list"
                          >
                            <el-checkbox
                              label="Patient has gastritis symptoms such as abdominal pain, cramping, acid reflux, or with a diagnosis of an associated high-risk condition such as Type-1 Diabetes Mellitus."
                            />
                            <br />

                            <el-checkbox
                              label="Patient is experiencing bacterial or viral infection symptoms (diarrhea, vomiting, and fever) and I would like to determine the best treatment."
                            />
                            <br />
                            <el-checkbox
                              label="Patient has a history of gastric infections, and I would like to determine whether it is a bacterial or viral infection."
                            />
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="others mt-30">
                        <el-row>
                          <el-col :xl="12" :lg="16" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">Others :</label>
                                <el-input
                                  v-model="gastroOrderInformation.others"
                                  type="textarea"
                                  placeholder="Enter Text"
                                />
                                <p class="err">
                                  <FormError
                                    errorName="medical_necessities.0.medical_necessity.others"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <div class="text-block mb-20">
                          <h4>
                            Because of this, the gastrointestinal infection
                            panel will help me to determine what bacteria,
                            parasites, or viruses illnesses to treat.
                          </h4>
                        </div>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadNailCaseType"
              >
                <div class="heading-block">
                  <h3>Nail Infection Panel Medical Necessity</h3>
                </div>
                <div class="text-block">
                  <p class="mb-30">
                    Since indicated that you wish to order a nail infection
                    panel, please complete the medical necessity letter below.
                    Please do not use a stamped signature on this form.
                  </p>
                  <div class="vue-form">
                    <el-form :model="nailOrderInformation">
                      <div class="heading-block mt-10 mb-20">
                        <h3>Dear Claims Specialist:</h3>
                        <p>
                          Please consider this letter of medical necessity as a
                          formal request for full coverage of the nail infection
                          panel testing services that I intend to prescribe for
                          your subscriber (Patient Name Listed Above. The
                          results will assist me in making patient specific
                          clinical decisions regarding the medical management of
                          your subscriber.
                        </p>
                        <p>
                          To provide the safest, most effective, and affordable
                          medical care possible, the requested molecular testing
                          is medically necessary for my patient for the
                          following reason(s):
                        </p>
                      </div>
                      <div>
                        <el-form-item>
                          <el-checkbox-group
                            v-model="nailOrderInformation.check_list"
                          >
                            <el-checkbox
                              label="Symptoms of nail fungal infections such as scaling under the nail, distorted nails, nail discoloration, yellow spots at the bottom of the nails, and brittle nails."
                            />
                            <br />

                            <el-checkbox
                              label="Patient has a nail injury, foot deformity, or skin infections."
                            />
                            <br />
                            <el-checkbox
                              label="Patient experiencing a history of nail infections, and I would like to determine the best treatment."
                            />
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="others mt-30">
                        <el-row>
                          <el-col :xl="12" :lg="16" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">Others :</label>
                                <el-input
                                  v-model="nailOrderInformation.others"
                                  type="textarea"
                                  placeholder="Enter Text"
                                />
                                <p class="err">
                                  <FormError
                                    errorName="medical_necessities.0.medical_necessity.others"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <div class="text-block mb-20">
                          <h4>
                            Because of this, the nail infection panel will help
                            me to determine what bacteria or fungus illnesses to
                            treat.
                          </h4>
                        </div>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadCovidFluCaseType"
              >
                <div class="heading-block">
                  <h3>Covid Flu Medical Necessity</h3>
                </div>
                <div class="text-block">
                  <p class="mb-30">
                    Since indicated that you wish to order a Respiratory
                    Pathogen Panel OR you have requested a Covid-19 PCR test and
                    reflex to the Respiratory Pathogen Panel if Covid-19 is
                    negative, please complete the Medical Necessity Letter
                    below. Please do not use a stamped signature on this form.
                  </p>
                  <div class="vue-form">
                    <el-form :model="covidFluOrderInformation">
                      <div class="heading-block mt-10 mb-20">
                        <h3>Dear Claims Specialist:</h3>
                        <p>
                          Please consider this letter of medical necessity as a
                          formal request for full coverage of the wound
                          infection panel testing services that I intend to
                          prescribe for your subscriber (Patient Name Listed
                          Above). The results will assist me in making patient
                          specific clinical decisions regarding the medical
                          management of your subscriber.
                        </p>
                        <p>
                          To provide the safest, most effective, and affordable
                          medical care possible, the requested molecular testing
                          is medically necessary for my patient for the
                          following reason(s):
                        </p>
                      </div>
                      <div>
                        <el-form-item>
                          <el-checkbox-group
                            v-model="covidFluOrderInformation.check_list"
                          >
                            <el-checkbox
                              label="If patient has tested negative for Covid-19, as their health care provider I wish to reflex to RPP"
                            />
                            <br />

                            <el-checkbox
                              label="Patient requires screening to Pathogen Exposure"
                            />
                            <br />
                            <el-checkbox
                              label="Patient is experiencing respiratory symptoms and I would like to determine best treatment"
                            />
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="others mt-30">
                        <el-row>
                          <el-col :xl="12" :lg="16" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">Others :</label>
                                <el-input
                                  v-model="covidFluOrderInformation.others"
                                  type="textarea"
                                  placeholder="Enter Text"
                                />
                                <p class="err">
                                  <FormError
                                    errorName="medical_necessities.0.medical_necessity.others"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <div class="text-block mb-20">
                          <h4>
                            Because of this, the Respiratory Pathogen Panel will
                            help me to determine what viruses or bacteria
                            illnesses to treat.
                          </h4>
                        </div>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadCovidCaseType"
              >
                <div class="heading-block">
                  <h3>Covid Medical Necessity</h3>
                </div>
                <div class="text-block">
                  <p class="mb-30">
                    Since indicated that you wish to order a Respiratory
                    Pathogen Panel OR you have requested a Covid-19 PCR test and
                    reflex to the Respiratory Pathogen Panel if Covid-19 is
                    negative, please complete the Medical Necessity Letter
                    below. Please do not use a stamped signature on this form.
                  </p>
                  <div class="vue-form">
                    <el-form :model="covidOrderInformation">
                      <div class="heading-block mt-10 mb-20">
                        <h3>Dear Claims Specialist:</h3>
                        <p>
                          Please consider this letter of medical necessity as a
                          formal request for full coverage of the wound
                          infection panel testing services that I intend to
                          prescribe for your subscriber (Patient Name Listed
                          Above). The results will assist me in making patient
                          specific clinical decisions regarding the medical
                          management of your subscriber.
                        </p>
                        <p>
                          To provide the safest, most effective, and affordable
                          medical care possible, the requested molecular testing
                          is medically necessary for my patient for the
                          following reason(s):
                        </p>
                      </div>
                      <div>
                        <el-form-item>
                          <el-checkbox-group
                            v-model="covidOrderInformation.check_list"
                          >
                            <el-checkbox
                              label="If patient has tested negative for Covid-19, as their health care provider I wish to reflex to RPP"
                            />
                            <br />

                            <el-checkbox
                              label="Patient requires screening to Pathogen Exposure"
                            />
                            <br />
                            <el-checkbox
                              label="Patient is experiencing respiratory symptoms and I would like to determine best treatment"
                            />
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="others mt-30">
                        <el-row>
                          <el-col :xl="12" :lg="16" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">Others :</label>
                                <el-input
                                  v-model="covidOrderInformation.others"
                                  type="textarea"
                                  placeholder="Enter Text"
                                />
                                <p class="err">
                                  <FormError
                                    errorName="medical_necessities.0.medical_necessity.others"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <div class="text-block mb-20">
                          <h4>
                            Because of this, the Respiratory Pathogen Panel will
                            help me to determine what viruses or bacteria
                            illnesses to treat.
                          </h4>
                        </div>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadRppCaseType"
              >
                <div class="heading-block">
                  <h3>Respiratory Pathogen Panel Medical Necessity</h3>
                </div>
                <div class="text-block">
                  <p class="mb-30">
                    Since indicated that you wish to order a Respiratory
                    Pathogen Panel OR you have requested a Covid-19 PCR test and
                    reflex to the Respiratory Pathogen Panel if Covid-19 is
                    negative, please complete the Medical Necessity Letter
                    below. Please do not use a stamped signature on this form.
                  </p>
                  <div class="vue-form">
                    <el-form :model="rppOrderInformation">
                      <div class="heading-block mt-10 mb-20">
                        <h3>Dear Claims Specialist:</h3>
                        <p>
                          Please consider this letter of medical necessity as a
                          formal request for full coverage of the wound
                          infection panel testing services that I intend to
                          prescribe for your subscriber (Patient Name Listed
                          Above). The results will assist me in making patient
                          specific clinical decisions regarding the medical
                          management of your subscriber.
                        </p>
                        <p>
                          To provide the safest, most effective, and affordable
                          medical care possible, the requested molecular testing
                          is medically necessary for my patient for the
                          following reason(s):
                        </p>
                      </div>
                      <div>
                        <el-form-item>
                          <el-checkbox-group
                            v-model="rppOrderInformation.check_list"
                          >
                            <el-checkbox
                              label="If patient has tested negative for Covid-19, as their health care provider I wish to reflex to RPP"
                            />
                            <br />

                            <el-checkbox
                              label="Patient requires screening to Pathogen Exposure"
                            />
                            <br />
                            <el-checkbox
                              label="Patient is experiencing respiratory symptoms and I would like to determine best treatment"
                            />
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="others mt-30">
                        <el-row>
                          <el-col :xl="12" :lg="16" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">Others :</label>
                                <el-input
                                  v-model="rppOrderInformation.others"
                                  type="textarea"
                                  placeholder="Enter Text"
                                />
                                <p class="err">
                                  <FormError
                                    errorName="medical_necessities.0.medical_necessity.others"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <div class="text-block mb-20">
                          <h4>
                            Because of this, the Respiratory Pathogen Panel will
                            help me to determine what viruses or bacteria
                            illnesses to treat.
                          </h4>
                        </div>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div
                class="case-creation__body pb-0 uti-medical-necessity"
                v-if="hadWoundCaseType"
              >
                <div class="heading-block">
                  <h3>Wound Infection Panel Medical Necessity</h3>
                </div>
                <div class="text-block">
                  <p class="mb-30">
                    Since indicated that you wish to order a wound infection
                    panel, please complete the medical necessity letter below.
                    Please do not use a stamped signature on this form.
                  </p>
                  <div class="vue-form">
                    <el-form :model="woundOrderInformation">
                      <div class="heading-block mt-10 mb-20">
                        <h3>Dear Claims Specialist:</h3>
                        <p>
                          Please consider this letter of medical necessity as a
                          formal request for full coverage of the wound
                          infection panel testing services that I intend to
                          prescribe for your subscriber (Patient Name Listed
                          Above). The results will assist me in making patient
                          specific clinical decisions regarding the medical
                          management of your subscriber.
                        </p>
                        <p>
                          To provide the safest, most effective, and affordable
                          medical care possible, the requested molecular testing
                          is medically necessary for my patient for the
                          following reason(s):
                        </p>
                      </div>
                      <div>
                        <el-form-item>
                          <el-checkbox-group
                            v-model="woundOrderInformation.check_list"
                          >
                            <el-checkbox label="Patient has wound(s)." />
                            <br />

                            <el-checkbox
                              label="Patient has symptoms such as swelling, tenderness, redness/red streaking, yellow or green pus on the body, and cloudy drainage."
                            />
                            <br />
                            <el-checkbox
                              label="Patient has a history of wound infections, and I would like to determine whether it is a bacterial or fungal infection."
                            />
                          </el-checkbox-group>
                        </el-form-item>
                      </div>
                      <div class="others mt-30">
                        <el-row>
                          <el-col :xl="12" :lg="16" :md="8" :sm="12" :xs="12">
                            <div class="case-creation__input">
                              <el-form-item>
                                <label for="text">Others :</label>
                                <el-input
                                  v-model="woundOrderInformation.others"
                                  type="textarea"
                                  placeholder="Enter Text"
                                />
                                <p class="err">
                                  <FormError
                                    errorName="medical_necessities.0.medical_necessity.others"
                                  ></FormError>
                                </p>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                        <div class="text-block mb-20">
                          <h4>
                            Because of this, the wound infection panel will help
                            me to determine what bacteria or fungus illnesses to
                            treat.
                          </h4>
                        </div>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div
        class="case-creation__divider"
        v-if="isAbleToAdd && hadCaseType"
      ></div>
      <!--Medical Necessity ends here-->
      <!-- Billing information start here -->
      <div
        class="case-creation__step case-creation__billing-information"
        v-if="caseInformation.billing_type == 'INSURANCE'"
      >
        <el-row>
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading justify-start">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-billing-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Billing Information</h3>
                </div>
                <div class="billing_alignmens">
                  <p class="err">
                    <FormError errorName="billing_info"></FormError>
                  </p>
                </div>
              </div>
              <div class="case-creation__billing-information__body">
                <div class="case-creation__tabs billing-information-tabs">
                  <el-tabs
                    v-model="activeName"
                    @tab-click="updateSelectedTabQuery"
                  >
                    <el-tab-pane name="first">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasError }"
                          >primary insurance</span
                        >
                      </template>
                      <PrimaryInsurance
                        v-if="activeName === 'first' && showInsuranceDob"
                        :primaryInsurance="primaryInsuranceForm"
                        :refreshDob="refreshPatientDob"
                        :parentRefs="$refs"
                        ref="primaryInsuranceForm"
                        :physicianPecos="pecosStatus"
                      ></PrimaryInsurance>
                    </el-tab-pane>
                    <el-tab-pane name="second">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasSecondaryErrors }"
                          >Secondary Insurance</span
                        >
                      </template>
                      <SecondaryInsurance
                        v-if="activeName === 'second' && showInsuranceDob"
                        :secondaryInsurance="secondaryInsuranceForm"
                        :parentRefs="$refs"
                        :refreshDob="true"
                        ref="secondaryInsuranceForm"
                      ></SecondaryInsurance>
                    </el-tab-pane>
                    <el-tab-pane name="third">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasTertiaryErrors }"
                          >Tertiary Insurance</span
                        >
                      </template>
                      <TertiaryInsuranceForm
                        v-if="activeName === 'third' && showInsuranceDob"
                        :tertiaryInsurance="tertiaryInsuranceForm"
                        :parentRefs="$refs"
                        :refreshDob="true"
                        ref="tertiaryInsuranceForm"
                      ></TertiaryInsuranceForm>
                    </el-tab-pane>
                    <el-tab-pane name="fourth">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasGuarantorErrors }"
                          >Guarantor</span
                        >
                      </template>
                      <GuarantorInsurance
                        v-if="activeName === 'fourth' && showInsuranceDob"
                        :guarantorInsurance="guarantorInsuranceForm"
                        ref="guarantorInsuranceForm"
                        :parentRefs="$refs"
                      ></GuarantorInsurance>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="case-creation__divider"></div>
      <!-- Billing information end here -->
      <div
        class="center-error-message pt-10 pb-20"
        v-if="this.getErrors && this.getErrors.critical_error"
      >
        <p class="err">
          <FormError errorName="critical_error"></FormError>
        </p>
      </div>
      <!-- Action buttons -->

      <div class="case-creation__actions fixed">
        <ul class="list">
          <li v-if="$route.params.phlebio_id">
            <el-button
              type="button"
              class="btn save-button"
              @click="checkCaseTypesToCreateAccession"
              >Create Accession</el-button
            >
          </li>
          <li>
            <el-button type="button" class="btn cancel-button" @click="goBack"
              >Cancel</el-button
            >
          </li>
        </ul>
      </div>
      <p class="err">
        <FormError errorName="critical_error"></FormError>
      </p>
    </div>

    <PatientSignature
      v-if="patientSignatureSettings"
      v-on:close="patientSignatureSettings = false"
      v-on:patientSignature="updatePatientSignature"
    ></PatientSignature>
    <PhysicianSignature
      v-if="physicianSignatureSettings"
      v-on:close="physicianSignatureSettings = false"
      v-on:physicianSignature="updatePhysicianSignature"
    ></PhysicianSignature>
    <GuardianSignature
      v-if="guardianSignatureSettings"
      v-on:close="guardianSignatureSettings = false"
      v-on:guardianSignature="updateGuardianSignature"
    ></GuardianSignature>
    <span class="case-creation__divider"></span>
    <ExistingCaseDetails
      v-if="errorDiloag"
      :existedCase="existedCaseDetails"
      :validationErrorMsg="validationError"
      :caseType="caseInformation.case_types"
      :phlebioInformation="caseInformationDetails"
      v-on:closeDialog="handleClose"
      v-on:closePopupDialog="handlePopUp"
      :phlebioOrder="approvalCase"
    ></ExistingCaseDetails>
    <div class="default-modal">
      <el-dialog
        v-model="multipleAccession"
        width="30%"
        :before-close="handlePopupClose"
        v-loading="loading"
        :close-on-click-modal="false"
      >
        <div class="dialog-header">
          <span class="header-part"
            >Select Casetype for Accession Creation</span
          >
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="handlePopupClose"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon" />
          </el-button>
        </div>
        <div class="popup-date pb-0">
          <div class="popup-el-select">
            <label>Case Type*:</label>
            <el-select
              v-model="accessionCaseType"
              placeholder="Select Case Type"
              @change="addAccessionSpecimenCaseTypes"
              multiple
              :multiple-limit="getCaseLimit"
            >
              <el-option
                v-for="(caseType, index) of getPhlebioInfo.case_types"
                :key="index"
                :value="caseType"
                :label="caseTypeMap[caseType]"
                :disabled="checkCaseTypeAccesionDisable(caseType)"
              ></el-option>
            </el-select>
          </div>
          <div
            class="popup-el-select"
            v-if="accessionCaseType && accessionCaseType.length"
          >
            <label>Specimen Types*:</label>

            <div
              class="specimen-case-type"
              v-for="(type, index) in this.caseInformation.sample_types"
              :key="index"
            >
              <span class="case-name">{{ caseTypeMap[type.case_type] }}</span>
              <span class="custom-select-capitalize">
                <el-select
                  v-model="type.sample_types"
                  multiple
                  filterable
                  allow-create
                  :reserve-keyword="false"
                  default-first-option
                  popper-class="custom-select-dropdown"
                >
                  <el-option
                    v-for="(specimen, index) in getSpecimenTypes[
                      type.case_type
                    ]"
                    :key="index"
                    :label="specimen"
                    :value="specimen"
                  ></el-option>
                </el-select>
                <p class="err">
                  <FormError
                    :errorName="`sample_types.${index}.sample_types`"
                  ></FormError></p
              ></span>
            </div>
          </div>
          <div class="dialog-footer">
            <el-button class="cancel-button" @click="handlePopupClose"
              >Cancel</el-button
            >
            <el-button
              :disabled="!accessionCaseType.length"
              class="blue-save-button"
              @click="createAccessionNumber"
              >Create Accession</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import AddTests from "@/components/cases/TestInformation";
import caseConstants from "@/config/constants/caseConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WoundPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/ToxicologyTestsPreview")
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const NailPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/NailPanelSelectedTests"
  )
);
const GastroPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GastroPanelSelectedTests"
  )
);
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);

import { startLoading } from "@/helpers/loadingHelper";

// billing Info
const PrimaryInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/PrimaryInsurance")
);
const SecondaryInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/SecondaryInsurance")
);
const TertiaryInsuranceForm = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/TertiaryInsurance")
);
const GuarantorInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/GuarantorInsurance")
);
const PatientSignature = defineAsyncComponent(() =>
  import("@/components/orders/PatientSignature")
);
const PhysicianSignature = defineAsyncComponent(() =>
  import("@/components/orders/PhysicianSignature")
);

const GuardianSignature = defineAsyncComponent(() =>
  import("@/components/orders/GuardianSignature")
);

import moment from "moment";
import InsuranceHelper from "@/mixins/InsuranceHelper";
import PatientInformation from "@/components/phlebioOrders/PatientInformationAdd";
import MedicationsAdd from "@/components/orders/MedicationsAdd";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

const GTIWomensHealthTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GTIWomensHealthTests"
  )
);
const UrinalysisTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/UrinalysisTestsPreview")
);
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  components: {
    AddTests,
    FormError,
    WoundPanelSelectedTests,
    UTIPanelSelectedTests,
    ToxicologyTestsPreview,
    BloodPanelSelectedTests,
    DefaultPanelSelectedTests,
    PrimaryInsurance,
    SecondaryInsurance,
    TertiaryInsuranceForm,
    GuarantorInsurance,
    PatientInformation,
    MedicationsAdd,
    PatientSignature,
    PhysicianSignature,
    GuardianSignature,
    MedicationsAdd,
    NailPanelSelectedTests,
    GastroPanelSelectedTests,
    GTIWomensHealthTests,
    UrinalysisTestsPreview,
    ExistingCaseDetails,
  },
  mixins: [caseDataHelper, AppHelper, InsuranceHelper, UserPermissionsHelper],
  data() {
    return {
      usersList: [],
      signatureInformation: {
        patient_signature: false,
        physician_signature: false,
        guardian_signature: false,
      },
      patientSignatureSettings: false,
      physicianSignatureSettings: false,
      guardianSignatureSettings: false,
      patient_sign: "",
      physician_sign: "",
      guardian_sign: "",
      toxicologyOrderInformation: {
        patient_name: "",
        patient_dob: "",
        date_of_service: new Date(),
        provider_name: "",
        check_list: [],
        please_explain: "",
        name_of_practice: "",
        name_of_clinician: "",
        clinician_npi: "",
        ordering_clinician_signature: "",
        date: new Date(),
      },
      urinalysisOrderInformation: {
        patient_name: "",
        patient_dob: "",
        date_of_service: new Date(),
        provider_name: "",
        check_list: [],
        please_explain: "",
        name_of_practice: "",
        name_of_clinician: "",
        clinician_npi: "",
        ordering_clinician_signature: "",
        date: new Date(),
      },
      utiOrderInformation: {
        icd_codes: [],
        check_list: [],
        patient_name: "",
        patient_dob: "",
        date_of_service: new Date(),
        others: "",
        name_of_practice: "",
        name_of_clinician: "",
        clinician_npi: "",
        ordering_clinician_signature: "",
        date: new Date(),
      },
      gastroOrderInformation: {
        check_list: [],
        others: "",
      },
      nailOrderInformation: {
        check_list: [],
        others: "",
      },
      covidFluOrderInformation: {
        check_list: [],
        others: "",
      },
      covidOrderInformation: {
        check_list: [],
        others: "",
      },
      rppOrderInformation: {
        check_list: [],
        others: "",
      },
      woundOrderInformation: {
        check_list: [],
        others: "",
      },
      defaultTime: [new Date()],

      page: 1,
      pageSize: 10,
      errorDiloag: false,
      caseUpdate: false,
      newCase: false,
      refreshPatientDob: true,

      filterString: "",
      buttonLoading: false,
      loading: false,
      addtestModelPopup: false,
      modalLoading: false,
      activeName: "first",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      faxInputValue: "",
      hideTestsDetails: false,

      //case information
      getSpecimenTypes: { ...caseConstants.CASE_TYPE_SPECIMEN_TYPE_MAP },
      fastingOptions: caseConstants.FASTING,
      caseInformation: {
        case_types: [],
        hospital: "",
        hospital_branch: "",
        ordering_physician: "",
        referring_physician: null,
        icd_10_codes: "",
        billing_type: "",
        requisition_order_id: "",
        ordering_date: "",
        received_date: "",
        collection_date: new Date(),
        received_date: new Date(),
        temperature: "",
        sample_types: "",
        icd_10_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
        ],
        is_fasting: "",
      },
      sampleTypesList: "",
      search_case_types: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
      selectedTab: null,
      hospitalBranches: [],
      allReferringPhysicians: [],
      show: false,
      showDob: false,
      showMedication: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },

      allTests: [],
      phlebioId: "",
      primaryInsuranceForm: {},
      secondaryInsuranceForm: {},
      tertiaryInsuranceForm: {},
      guarantorInsuranceForm: {},
      hospitalsData: {},
      physiciansData: {},
      patientInformation: {},
      hospitalsLoading: false,
      physicianLoading: false,
      selectedSampleTypes: "",
      selectedSampleTypes1: "",
      selectedSampleTypes2: "",
      showInsuranceDob: false,
      labdaqFacilityData: {},
      toxicology_ereq_form: [],
      physician_notes: "",
      custom_test_profiles: [],
      medicationsList: [],
      options: caseConstants.TOX_CHECK_LIST,
      showOralChecklist: false,
      showChekclist: false,
      selectedSpecimen: "",
      medicationMappedTestsData: [],
      medicationPopup: false,
      addMedicationTests: false,
      medicationMismatchedData: [],
      icdErrorDialog: false,
      existedCaseDetails: {},
      validationError: "",
      caseInformationDetails: {},
      approvalCase: true,
      multipleAccession: false,
      testInfo: [],
      specimenTypes: [],
      accessionCaseType: [],
    };
  },
  computed: {
    availableOptions() {
      if (this.toxicology_ereq_form.includes("Screen Reflex to Confirmation")) {
        // If "Screen Reflex to Confirmation" is selected, enable "Confirm All Prescribed Medications of Interest"
        return this.options.map((option) => ({
          ...option,
          disabled:
            option.label !== "Screen Reflex to Confirmation" &&
            option.label !== "Confirm All Prescribed Medications of Interest" &&
            option.label !== "Confirm Tests Selected Below",
        }));
      } else if (
        this.toxicology_ereq_form.includes(
          "Confirm All Prescribed Medications of Interest"
        )
      ) {
        // If "Confirm All Prescribed Medications of Interest" is selected, enable "Screen Reflex to Confirmation"
        return this.options.map((option) => ({
          ...option,
          disabled:
            option.label !== "Confirm All Prescribed Medications of Interest" &&
            option.label !== "Screen Reflex to Confirmation" &&
            option.label !== "Confirm Tests Selected Below",
        }));
      } else if (
        this.toxicology_ereq_form.includes("Confirm Tests Selected Below")
      ) {
        // If "Confirm All Prescribed Medications of Interest" is selected, enable "Screen Reflex to Confirmation"
        return this.options.map((option) => ({
          ...option,
          disabled:
            option.label !== "Confirm All Prescribed Medications of Interest" &&
            option.label !== "Screen Reflex to Confirmation" &&
            option.label !== "Confirm Tests Selected Below",
        }));
      } else {
        // If neither is selected, enable only the respective options
        return this.options;
      }
    },
    checkCaseValidation() {
      if (this.$route.params.phlebio_id) {
        return false;
      }
      return true;
    },
    checkUser() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        return true;
      }
      return false;
    },

    isAbleToAdd() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "HOSPITAL_PHYSICIAN"
      ) {
        return true;
      }
      return false;
    },
    hadCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        (this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1 ||
          this.caseInformation.case_types.indexOf("UTI") > -1 ||
          this.caseInformation.case_types.indexOf("GASTRO") > -1 ||
          this.caseInformation.case_types.indexOf("NAIL") > -1 ||
          this.caseInformation.case_types.indexOf("COVID_FLU") > -1 ||
          this.caseInformation.case_types.indexOf("COVID") > -1 ||
          this.caseInformation.case_types.indexOf(
            "RESPIRATORY_PATHOGEN_PANEL"
          ) > -1 ||
          this.caseInformation.case_types.indexOf("WOUND") > -1 ||
          this.caseInformation.case_types.indexOf("URINALYSIS") > -1)
      ) {
        return true;
      }
      return false;
    },
    hadToxicCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1
      ) {
        return true;
      }
      return false;
    },
    hadUrinalysisCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("URINALYSIS") > -1
      ) {
        return true;
      }
      return false;
    },
    hadUTICaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("UTI") > -1
      ) {
        return true;
      }
      return false;
    },
    hadGastroCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("GASTRO") > -1
      ) {
        return true;
      }
      return false;
    },
    hadNailCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("NAIL") > -1
      ) {
        return true;
      }
      return false;
    },
    hadCovidFluCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("COVID_FLU") > -1
      ) {
        return true;
      }
      return false;
    },
    hadCovidCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("COVID") > -1
      ) {
        return true;
      }
      return false;
    },
    hadRppCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("RESPIRATORY_PATHOGEN_PANEL") >
          -1
      ) {
        return true;
      }
      return false;
    },
    hadWoundCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("WOUND") > -1
      ) {
        return true;
      }
      return false;
    },
    hadBloodCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
      ) {
        return true;
      }
      return false;
    },
    hasError() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.primary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasSecondaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.secondary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasTertiaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.tertiary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasGuarantorErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf("billing_info.insurance.guarantor") !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    isAbleToAddFasting() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "MARKETER",
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    ...mapGetters("phlebio", [
      "getPhlebioInfo",
      "getCaseConversionStatus",
      "getValidationErrors",
      "getPhlebioTestInfo",
    ]),
    ...mapGetters("cases", [
      "getMedicationCreateStatus",
      "getAllMedications",
      "getAllSampleTypes",
      "getMedicationTests",
    ]),

    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    ...mapGetters("userAccounts", ["getAllUsers"]),
    ...mapGetters("profile", ["getProfileData"]),
    getCaseTypeLimit() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length &&
        this.caseInformation.case_types.indexOf("COVID_FLU") != -1
      ) {
        return 2;
      }
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length &&
        this.caseInformation.case_types.indexOf("URINALYSIS") != -1
      ) {
        return 2;
      }

      return 3;
    },
    isTestInfoError() {
      if (this.getErrors && this.getErrors.tests_info) {
        return true;
      }
      return false;
    },
    isMedicationError() {
      if (this.getErrors && this.getErrors.medication) {
        return true;
      }
      return false;
    },

    checkCaseTypeDisable() {
      return (caseType) => {
        if (
          this.caseInformation.case_types &&
          this.caseInformation.case_types.length &&
          this.caseInformation.case_types.length == 2 &&
          this.caseInformation.case_types.indexOf("COVID_FLU") == -1 &&
          caseType.value == "COVID_FLU"
        ) {
          return true;
        }
        if (
          this.caseInformation.case_types &&
          this.caseInformation.case_types.length &&
          this.caseInformation.case_types.length == 2 &&
          this.caseInformation.case_types.indexOf("URINALYSIS") == -1 &&
          caseType.value == "URINALYSIS"
        ) {
          return true;
        }
        return false;
      };
    },

    getCaseTypes() {
      return this.search_case_types;
    },
    getTestsInformationObject() {
      const obj = {};
      if (this.allTests) {
        this.allTests.forEach((el) => {
          obj[el._id] = el;
        });
      }
      return obj;
    },

    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", [
      "getAllPhysicians",
      "getPhysicianSignatureUpdate",
      "getSinglePhysician",
    ]),
    ...mapGetters("branches", ["getAllBranches"]),
    hasNoCaseTypes() {
      if (
        !this.caseInformation ||
        !this.caseInformation.case_types ||
        this.caseInformation.case_types.length === 0
      ) {
        return true;
      }
      return false;
    },
    hasCaseType() {
      if (
        (this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1) ||
        this.caseInformation.case_types.indexOf("PGX_TEST") > -1
      ) {
        return true;
      }
      return false;
    },
    isFacilityUser() {
      if (this.getAuthenticatedUser && this.getAuthenticatedUser.user_type) {
        let users = [
          "HOSPITAL_PHYSICIAN",
          "HOSPITAL_ADMIN",
          "HOSPITAL_ACCOUNT_MANAGER",
          "MARKETER",
          "HOSPITAL_MARKETING_MANAGER",
        ];
        if (users.indexOf(this.getAuthenticatedUser.user_type) !== -1) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    },
    isToxicCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length &&
        this.caseInformation.case_types.includes("TOXICOLOGY")
      ) {
        return true;
      }
      return false;
    },
    CaseTypeDisable() {
      if (
        this.getPhlebioInfo &&
        this.getPhlebioInfo.accession_data &&
        this.getPhlebioInfo.accession_data.length
      ) {
        return this.getPhlebioInfo.accession_data.map((obj) => obj.case_type);
      }
      return [];
    },
    getCaseLimit() {
      return 1;
    },
  },

  async mounted() {
    this.loadInitData();
  },

  methods: {
    setShowChecklist(checklist) {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.includes("TOXICOLOGY")
      ) {
        if (checklist && checklist.length) {
          this.selectedSpecimen = checklist[0];
        }
        if (checklist && checklist[0] == "Oral") {
          this.showChekclist = false;
          this.showOralChecklist = true;
        } else {
          this.showOralChecklist = false;
        }
        if (checklist && checklist[0] == "Urine") {
          this.showOralChecklist = false;
          this.showChekclist = true;
        } else {
          this.showChekclist = false;
          this.toxicology_ereq_form = [];
        }
      }
    },
    updateCheckedOptions(label, checked) {
      const specialOptions = [
        "Screen Reflex to Confirmation",
        "Confirm All Prescribed Medications of Interest",
        "Confirm Tests Selected Below",
      ];

      if (label === "Screen Reflex to Confirmation" && checked) {
        // If "Screen Reflex to Confirmation" is checked, also check "Confirm All Prescribed Medications of Interest"
        this.toxicology_ereq_form.push(
          "Confirm All Prescribed Medications of Interest"
        );
      }

      if (
        specialOptions.every(
          (option) => !this.toxicology_ereq_form.includes(option)
        )
      ) {
        // If none of the special options are selected, keep only the last selected option
        this.toxicology_ereq_form = this.toxicology_ereq_form.slice(-1);
      } else if (
        specialOptions.every((option) =>
          this.toxicology_ereq_form.includes(option)
        )
      ) {
        // If all special options are selected, keep all of them
        this.toxicology_ereq_form = specialOptions;
      } else {
        // If only some of the special options are selected, keep them along with any other selected options
        this.toxicology_ereq_form = this.toxicology_ereq_form.filter((option) =>
          specialOptions.includes(option)
        );
      }
      this.clearTestData();
    },
    clearTestData() {
      this.panelsTestsData.selectedTestIds = [];
      this.panelsTestsData.selectedCoriellPanels = [];
    },

    async addNewSampleType(event) {
      let sampleTypes = event;
      let data = this.getAllSampleTypes.map((a) => a.sample_type.toLowerCase());

      let difference = sampleTypes.filter(
        (x) => !data.includes(x.toLowerCase())
      );
      if (difference && difference.length) {
        let params = {
          sample_type: this.changetocaptila(difference[0]),
        };

        await this.$store.dispatch("cases/createSampleTypes", params);
        this.fetchSpecimenTypes();
      }
    },
    changetocaptila(str) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    },
    async fetchSpecimenTypes() {
      let params = { get_all: true };
      await this.$store.dispatch("cases/fetchAllSampleTypes", params);
    },
    async fetchPhysicianDetails() {
      await this.$store.dispatch("physicians/fetchSinglePhysician", {
        physician_id: this.caseInformation.ordering_physician,
      });
      if (this.getSinglePhysician && this.getSinglePhysician.signature) {
        this.physician_sign = this.getSinglePhysician.signature;
      } else {
        this.physician_sign = "";
      }
    },

    addSpecimenCaseTypes() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
      ) {
        this.caseInformation.hospital = null;
        this.caseInformation.ordering_physician = undefined;
        this.caseInformation.hospital_branch = null;
        this.physician_sign = null;
      }
      if (!this.caseInformation.sample_types) {
        this.caseInformation.sample_types = [];
      }
      if (this.caseInformation && this.caseInformation.case_types.length == 0) {
        this.caseInformation.sample_types = [];
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length
      ) {
        this.caseInformation.case_types.forEach((singleCaseType) => {
          let caseSampleTypeExisted = this.caseInformation.sample_types.find(
            (e) => e.case_type == singleCaseType
          );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [], // we are to add default case type here
            };
            this.caseInformation.sample_types.push(caseTypeDefaultSampleName);
          }
        });
        // we need to remove not existed
        this.caseInformation.sample_types =
          this.caseInformation.sample_types.filter((sampleTypeData) =>
            this.caseInformation.case_types.includes(sampleTypeData.case_type)
          );
      } else {
        this.caseInformation.sample_types = [];
      }
      this.setToxicMedicalNecessity();
    },
    openPatientSignatureSettings() {
      this.patientSignatureSettings = true;
    },
    openPhysicianSignatureSettings() {
      this.physicianSignatureSettings = true;
    },
    openGuardianSignatureSettings() {
      this.guardianSignatureSettings = true;
    },
    handlePatientSign() {
      if (this.signatureInformation.patient_signature) {
        this.patient_sign = "";
      }
    },
    handlePhysicianSign() {
      if (this.signatureInformation.physician_signature) {
        this.physician_sign = "";
      }
    },
    handleGuardianSign() {
      if (this.signatureInformation.guardian_signature) {
        this.guardian_sign = "";
      }
    },
    updateData(data) {
      this.setToxicMedicalNecessity();
    },
    updatePatientData(data) {
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.primary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.primary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.secondary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.secondary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.tertiary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.tertiary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.guarantor
      ) {
        this.showInsuranceDob = false;
        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.guarantorInsuranceForm = data.billing_info.insurance.guarantor;
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.medication &&
        data.medication.length != 0
      ) {
        this.showMedication = false;
        setTimeout(() => {
          this.showMedication = true;
        }, 100);
        this.medicationsList = data.medication;
      } else {
        this.showMedication = false;
        setTimeout(() => {
          this.showMedication = true;
        }, 100);
        this.medicationsList = [];
      }
    },
    getSelectedHospital(hospitalId) {
      return this.getAllHospitals.data
        .filter((hospital) => hospitalId.indexOf(hospital._id) != -1)
        .flatMap((hospital) => hospital.name)
        .join(", ");
    },
    getSelectedPhysician(physicianId) {
      return this.getAllPhysicians.data.find(
        (physician) => physician._id == physicianId
      );
    },
    manageCaseTypes() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("URINALYSIS") > -1
      ) {
        this.search_case_types = caseConstants.CASE_TYPES_DATA.filter(
          (caseType) => caseType.value != "COVID_FLU"
        );
      } else if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("COVID_FLU") > -1
      ) {
        this.search_case_types = caseConstants.CASE_TYPES_DATA.filter(
          (caseType) => caseType.value != "URINALYSIS"
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },
    setToxicMedicalNecessity() {
      let data = this.$refs["patientInformationForm"];

      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        (this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1 ||
          this.caseInformation.case_types.indexOf("UTI") > -1 ||
          this.caseInformation.case_types.indexOf("URINALYSIS") > -1)
      ) {
        if (data.patientInformation.middle_name) {
          this.toxicologyOrderInformation.patient_name =
            data.patientInformation.first_name.trim() +
            " " +
            data.patientInformation.middle_name.trim() +
            " " +
            data.patientInformation.last_name.trim();
        } else {
          this.toxicologyOrderInformation.patient_name =
            data.patientInformation.first_name.trim() +
            " " +
            data.patientInformation.last_name.trim();
        }

        this.toxicologyOrderInformation.patient_dob =
          data.patientInformation.date_of_birth;
        if (data.patientInformation.middle_name) {
          this.utiOrderInformation.patient_name =
            data.patientInformation.first_name.trim() +
            " " +
            data.patientInformation.middle_name.trim() +
            " " +
            data.patientInformation.last_name.trim();
        } else {
          this.utiOrderInformation.patient_name =
            data.patientInformation.first_name.trim() +
            " " +
            data.patientInformation.last_name.trim();
        }
        this.utiOrderInformation.patient_dob =
          data.patientInformation.date_of_birth;
        if (data.patientInformation.middle_name) {
          this.urinalysisOrderInformation.patient_name =
            data.patientInformation.first_name.trim() +
            " " +
            data.patientInformation.middle_name.trim() +
            " " +
            data.patientInformation.last_name.trim();
        } else {
          this.urinalysisOrderInformation.patient_name =
            data.patientInformation.first_name.trim() +
            " " +
            data.patientInformation.last_name.trim();
        }
        this.urinalysisOrderInformation.patient_dob =
          data.patientInformation.date_of_birth;
        this.setUtiPhysicianData();
        if (this.caseInformation && this.caseInformation.hospital) {
          this.utiOrderInformation.name_of_practice = this.getSelectedHospital(
            this.caseInformation.hospital
          );
          this.toxicologyOrderInformation.name_of_practice =
            this.getSelectedHospital(this.caseInformation.hospital);
          this.urinalysisOrderInformation.name_of_practice =
            this.getSelectedHospital(this.caseInformation.hospital);
        }
      }
    },

    selectedTestsDetails() {
      const data = [];
      if (this.panelsTestsData.selectedTestIds) {
        this.panelsTestsData.selectedTestIds.forEach((el, index) => {
          if (
            el &&
            this.getTestsInformationObject[el] &&
            this.caseInformation.case_types.indexOf(
              this.getTestsInformationObject[el].case_type_code
            ) != -1
          ) {
            data.push(this.getTestsInformationObject[el]);
          } else {
            this.panelsTestsData.selectedTestIds.splice(index, 1);
          }
        });
      }

      return data;
    },
    async remove(index) {
      this.caseInformation.case_types.splice(index, 1);
      this.caseInformation.sample_types.splice(index, 1);
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
      ) {
        this.caseInformation.hospital = null;
        this.caseInformation.ordering_physician = undefined;
        this.caseInformation.hospital_branch = null;
        this.physician_sign = null;
      }
    },
    async fetchHospitalsData() {
      this.hospitalsLoading = true;
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      if (
        (this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1) ||
        (this.getPhlebioInfo &&
          this.getPhlebioInfo.case_types &&
          this.getPhlebioInfo.case_types.indexOf("CLINICAL_CHEMISTRY") > -1)
      ) {
        let reportsData = JSON.parse(JSON.stringify(this.getAllHospitals.data));
        let facilityData = reportsData.filter((facility) => facility.settings);
        let labdaqData = facilityData.filter(
          (labdaq) => labdaq.settings.is_labdaq === true
        );
        this.labdaqFacilityData = labdaqData;
      } else {
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      }

      this.hospitalsLoading = false;
    },
    async fetchPhysiciansData() {
      this.physicianLoading = true;

      await this.$store.dispatch("physicians/fetchAllPhysicians", {
        get_all: true,
      });
      this.allReferringPhysicians =
        this.getAllPhysicians &&
        this.getAllPhysicians.data &&
        this.getAllPhysicians.data.length
          ? this.getAllPhysicians.data
          : [];
      this.physicianLoading = false;
    },
    async loadInitData() {
      const loading = startLoading();
      try {
        if (this.$route.params.phlebio_id) {
          this.checkCaseInformation();
          this.show = true;
        } else {
          this.loading = false;
          this.caseForm = true;
        }

        let params = { get_all: true };
        await this.$store.dispatch("help/fetchAllStates");

        await this.$store.dispatch("labs/fetchAllLabs", params);
        this.showDob = true;
        this.showInsuranceDob = true;
        this.showMedication = true;
        await this.getLabCaseTypes();
        this.caseInformation.lab = this.getUserPrimaryLabId;

        loading.close();
      } catch (err) {
        loading.close();
      }
    },

    parseOrderInfo(patientInfo) {
      let params = { ...patientInfo };

      if (params.patient_dob != "") {
        params.patient_dob = moment(params.patient_dob).format("YYYY-MM-DD");
      }
      if (!params.please_explain) delete params.please_explain;
      if (!params.check_list) delete params.check_list;
      if (!params.ordering_clinician_signature)
        delete params.ordering_clinician_signature;
      return params;
    },
    parseUTIOrderInfo(patientInfo) {
      let params = { ...patientInfo };

      if (params.patient_dob != "") {
        params.patient_dob = moment(params.patient_dob).format("YYYY-MM-DD");
      }
      if (!params.others) delete params.others;
      if (!params.ordering_clinician_signature)
        delete params.ordering_clinician_signature;
      if (!params.check_list) delete params.check_list;
      return params;
    },
    setToxicOrderInfo() {
      return {
        check_list: this.toxicologyOrderInformation.check_list || [],
        patient_name: this.toxicologyOrderInformation.patient_name || "",
        patient_dob: this.toxicologyOrderInformation.patient_dob || "",
        date_of_service: this.toxicologyOrderInformation.date_of_service || "",
        provider_name: this.toxicologyOrderInformation.provider_name || "",
        please_explain: this.toxicologyOrderInformation.please_explain || "",
        name_of_practice:
          this.toxicologyOrderInformation.name_of_practice || "",
        name_of_clinician:
          this.toxicologyOrderInformation.name_of_clinician || "",
        clinician_npi: this.toxicologyOrderInformation.clinician_npi || "",
        ordering_clinician_signature:
          this.toxicologyOrderInformation.ordering_clinician_signature || "",
        date: this.toxicologyOrderInformation.date || "",
      };
    },
    setUTIOrderInfo() {
      return {
        check_list: this.utiOrderInformation.check_list || [],
        patient_name: this.utiOrderInformation.patient_name || "",
        patient_dob: this.utiOrderInformation.patient_dob || "",
        date_of_service: this.utiOrderInformation.date_of_service || "",
        others: this.utiOrderInformation.others || "",
        icd_codes:
          this.caseInformation.icd_10_codesForm
            .filter((e) => e.value)
            .map((e) => e.value) || [],
        name_of_practice: this.utiOrderInformation.name_of_practice || "",
        name_of_clinician: this.utiOrderInformation.name_of_clinician || "",
        clinician_npi: this.utiOrderInformation.clinician_npi || "",
        ordering_clinician_signature:
          this.utiOrderInformation.ordering_clinician_signature || "",
        date: this.utiOrderInformation.date || "",
      };
    },
    setUrinalysisOrderInfo() {
      return {
        check_list: this.urinalysisOrderInformation.check_list || [],
        patient_name: this.urinalysisOrderInformation.patient_name || "",
        patient_dob: this.urinalysisOrderInformation.patient_dob || "",
        date_of_service: this.urinalysisOrderInformation.date_of_service || "",
        provider_name: this.urinalysisOrderInformation.provider_name || "",
        please_explain: this.urinalysisOrderInformation.please_explain || "",
        name_of_practice:
          this.urinalysisOrderInformation.name_of_practice || "",
        name_of_clinician:
          this.urinalysisOrderInformation.name_of_clinician || "",
        clinician_npi: this.urinalysisOrderInformation.clinician_npi || "",
        ordering_clinician_signature:
          this.urinalysisOrderInformation.ordering_clinician_signature || "",
        date: this.urinalysisOrderInformation.date || "",
      };
    },
    parseInsuranceForm(insuranceData) {
      let params = { ...insuranceData };
      if (params.date_of_birth) {
        params.date_of_birth = moment(params.date_of_birth).format(
          "YYYY-MM-DD"
        );
      }

      // filtering the object
      // removing non entered values
      Object.keys(params).forEach((keyValue) => {
        if (!params[keyValue]) {
          delete params[keyValue];
        }
      });

      return params;
    },
    updatePatientSignature(sign) {
      this.patientSignatureSettings = false;
      this.patient_sign = sign;
    },
    updatePhysicianSignature(sign) {
      this.physicianSignatureSettings = false;
      this.physician_sign = sign;
    },
    updateGuardianSignature(sign) {
      this.guardianSignatureSettings = false;
      this.guardian_sign = sign;
    },
    parseSignatureSettings() {
      let params = {};
      params = {
        patient_signature: this.signatureInformation.patient_signature,

        physician_signature: this.signatureInformation.physician_signature,

        guardian_signature: this.signatureInformation.guardian_signature,
      };
      if (this.patient_sign) {
        params.patient_sign = this.patient_sign;
      }
      if (this.physician_sign) {
        params.physician_sign = this.physician_sign;
      }
      if (this.guardian_sign) {
        params.guardian_sign = this.guardian_sign;
      }

      return params;
    },
    checkCaseTypesToCreateAccession() {
      if (
        this.getPhlebioInfo &&
        this.getPhlebioInfo.case_types &&
        this.getPhlebioInfo.case_types.length > 1
      ) {
        this.multipleAccession = true;
      } else {
        this.accessionCreation();
      }
    },
    handlePopupClose() {
      this.multipleAccession = false;
      this.accessionCaseType = [];
      this.caseInformation.sample_type = "";
    },
    async createAccessionNumber() {
      try {
        this.specimenPreparation();
        await this.fetchPhlebioTestsInfo();
        if (this.getPhlebioTestInfo) {
          this.multipleAccession = false;
          await this.accessionCreation();
        } else {
          errorNotification("Unable to Fetch Test Information");
        }
      } catch (error) {
        console.log(error);
        this.multipleAccession = true;
      }
    },
    specimenPreparation() {
      if (
        this.getPhlebioInfo &&
        this.caseInformation.sample_types &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length > 1
      ) {
        const selectedSpecimen = this.caseInformation.sample_types.filter(
          (caseObj) => caseObj.case_type === this.accessionCaseType[0]
        );
        this.specimenTypes = selectedSpecimen;
      }
    },
    async fetchPhlebioTestsInfo() {
      let params = {
        phlebio_order_id: this.getPhlebioInfo.phlebio_order_id,
        case_type: this.accessionCaseType.length
          ? this.accessionCaseType
          : this.caseInformation.case_types,
      };
      await this.$store.dispatch(
        "phlebio/fetchSinglePhlebioOrderTestsInfo",
        params
      );
    },
    checkCaseTypeAccesionDisable(value) {
      return this.CaseTypeDisable.includes(value);
    },
    addAccessionSpecimenCaseTypes() {
      if (!this.caseInformation.sample_types) {
        this.caseInformation.sample_types = [];
      }
      if (this.caseInformation && this.caseInformation.case_types.length == 0) {
        this.caseInformation.sample_types = [];
      }
      if (this.accessionCaseType && this.accessionCaseType.length) {
        this.accessionCaseType.forEach((singleCaseType) => {
          let caseSampleTypeExisted = this.caseInformation.sample_types.find(
            (e) => e.case_type == singleCaseType
          );
          if (!caseSampleTypeExisted) {
            let defaultSampleTypes = this.getSpecimenTypes[singleCaseType];
            let caseTypeDefaultSampleName = {
              case_type: singleCaseType,
              // sample_types: [],
              sample_types:
                defaultSampleTypes.length == 1 ? defaultSampleTypes : [], // we are to add default case type here
            };
            this.caseInformation.sample_types.push(caseTypeDefaultSampleName);
          }
        });

        // we need to remove not existed

        this.caseInformation.sample_types =
          this.caseInformation.sample_types.filter((sampleTypeData) =>
            this.caseInformation.case_types.includes(sampleTypeData.case_type)
          );
      } else {
        this.caseInformation.sample_types = [];
      }
    },
    async accessionCreation() {
      this.loading = true;
      let params = this.prepreDataFromFormData();
      if (this.getPhlebioTestInfo && this.getPhlebioTestInfo.data) {
        params.tests_info = this.getPhlebioTestInfo.data;
      }
      await this.$store.dispatch("phlebio/convertToCase", params);
      if (this.getCaseConversionStatus) {
        this.accessionCaseType = [];
        this.caseInformation.sample_type = "";
        successNotification("Convert To Case Successfully");
        this.$router.push({
          name: "AllPhlebioRequests",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      } else if (
        this.getValidationErrors &&
        this.getValidationErrors.error_code &&
        this.getValidationErrors.error_code == "DUPLICATE_EXISTED"
      ) {
        this.errorDiloag = true;
        this.validationError = this.getValidationErrors.error_code;
        if (
          this.getValidationErrors.errors &&
          this.getValidationErrors.errors.existed_details
        )
          this.existedCaseDetails =
            this.getValidationErrors.errors.existed_details;
        this.caseInformationDetails = this.prepreDataFromFormData();
      } else {
        if (!this.getErrors || this.getError) {
          errorNotification("Error While creating acession");
          this.accessionCaseType = [];
          this.caseInformation.sample_type = "";
        }
      }
      this.loading = false;
    },
    goBack() {
      if (
        this.$route.params &&
        this.$route.params.phlebio_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "AllPhlebioRequests",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      }
    },
    prepreDataFromFormData() {
      let patientFormInfo = this.$refs["patientInformationForm"];

      let params = this.parseCaseInfo();
      params.phlebio_order_id = this.getPhlebioInfo.phlebio_order_id;
      if (this.getPhlebioInfo && this.getPhlebioInfo.attachments) {
        params.attachments = this.getPhlebioInfo.attachments;
      }
      let patientInfo = patientFormInfo.formatPatientInfo();

      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );

        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }

      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformation.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      }
      params.signature_settings = this.parseSignatureSettings();
      params.patient_info = patientInfo;
      if (this.addMedicationTests) {
        if (Array.isArray(this.medicationMismatchedData)) {
          let uniqueTestIds = [
            ...new Set(this.medicationMismatchedData.map((item) => item._id)),
          ];
          uniqueTestIds.forEach((id) => {
            if (!this.panelsTestsData.selectedTestIds.includes(id)) {
              this.panelsTestsData.selectedTestIds.push(id);
            }
          });
          // Ensure tests_info contains only unique values
          let testsInfo = [
            ...new Set([
              ...uniqueTestIds,
              ...this.panelsTestsData.selectedTestIds,
            ]),
          ];
          params.tests_info = testsInfo;
        } else {
          console.error(
            "this.medicationMismatchedData is not an array or is undefined/null."
          );
        }
      } else {
        params.tests_info = this.panelsTestsData.selectedTestIds;
      }
      params.coriell_test_panels = this.panelsTestsData.selectedCoriellPanels;
      params.custom_test_profiles = this.custom_test_profiles;
      let medicationFormDetails = this.$refs["medicationFormDetails"];
      if (medicationFormDetails) {
        params.medication = medicationFormDetails.getMedicationsList();
      }
      if (this.physician_notes) {
        params.physician_notes = this.physician_notes;
      }
      if (
        this.hadBloodCaseType &&
        (this.caseInformation.is_fasting == true ||
          this.caseInformation.is_fasting == false) &&
        this.isAbleToAddFasting
      ) {
        params.is_fasting = this.caseInformation.is_fasting;
      }
      if (
        this.IsAbleToAdd &&
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1 &&
        (this.toxicologyOrderInformation.patient_name ||
          this.toxicologyOrderInformation.patient_dob ||
          this.toxicologyOrderInformation.date_of_service ||
          this.toxicologyOrderInformation.provider_name ||
          this.toxicologyOrderInformation.please_explain ||
          this.toxicologyOrderInformation.check_list.length ||
          this.toxicologyOrderInformation.name_of_practice ||
          this.toxicologyOrderInformation.name_of_clinician ||
          this.toxicologyOrderInformation.clinician_npi ||
          this.toxicologyOrderInformation.ordering_clinician_signature ||
          this.toxicologyOrderInformation.date)
      ) {
        params.toxicology_order_medical_necessity_fields = this.parseOrderInfo(
          this.setToxicOrderInfo()
        );
      }
      if (
        this.IsAbleToAdd &&
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("UTI") > -1 &&
        (this.utiOrderInformation.patient_name ||
          this.utiOrderInformation.icd_codes.length ||
          this.utiOrderInformation.check_list.length ||
          this.utiOrderInformation.date ||
          this.utiOrderInformation.patient_dob ||
          this.utiOrderInformation.date_of_service ||
          this.utiOrderInformation.others ||
          this.utiOrderInformation.name_of_practice ||
          this.utiOrderInformation.name_of_clinician ||
          this.utiOrderInformation.clinician_npi ||
          this.utiOrderInformation.ordering_clinician_signature)
      ) {
        params.urinary_tract_infectious_medical_necessity_fields =
          this.parseUTIOrderInfo(this.setUTIOrderInfo());
      }
      if (
        this.IsAbleToAdd &&
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("URINALYSIS") > -1 &&
        (this.urinalysisOrderInformation.patient_name ||
          this.urinalysisOrderInformation.patient_dob ||
          this.urinalysisOrderInformation.date_of_service ||
          this.urinalysisOrderInformation.provider_name ||
          this.urinalysisOrderInformation.please_explain ||
          this.urinalysisOrderInformation.check_list.length ||
          this.urinalysisOrderInformation.name_of_practice ||
          this.urinalysisOrderInformation.name_of_clinician ||
          this.urinalysisOrderInformation.clinician_npi ||
          this.urinalysisOrderInformation.ordering_clinician_signature ||
          this.urinalysisOrderInformation.date)
      ) {
        params.urinalysis_order_medical_necessity_fields = this.parseOrderInfo(
          this.setUrinalysisOrderInfo()
        );
      }
      let medicalNecessities = [];
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("GASTRO") > -1 &&
        (this.gastroOrderInformation.others ||
          this.gastroOrderInformation.check_list.length)
      ) {
        let medicalNecessity = {
          medical_necessity: {
            check_list: this.gastroOrderInformation.check_list || [],
            others: this.gastroOrderInformation.others || "",
          },
          case_type: "GASTRO",
        };
        medicalNecessities.push(medicalNecessity);
      } else {
        if (
          this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("GASTRO") > -1
        ) {
          let medicalNecessity = {
            medical_necessity: {},
            case_type: "GASTRO",
          };
          medicalNecessities.push(medicalNecessity);
        }
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("NAIL") > -1 &&
        (this.nailOrderInformation.others ||
          this.nailOrderInformation.check_list.length)
      ) {
        let medicalNecessity = {
          medical_necessity: {
            check_list: this.nailOrderInformation.check_list || [],
            others: this.nailOrderInformation.others || "",
          },
          case_type: "NAIL",
        };
        medicalNecessities.push(medicalNecessity);
      } else {
        if (
          this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("NAIL") > -1
        ) {
          let medicalNecessity = {
            medical_necessity: {},
            case_type: "NAIL",
          };
          medicalNecessities.push(medicalNecessity);
        }
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("COVID_FLU") > -1 &&
        (this.covidFluOrderInformation.others ||
          this.covidFluOrderInformation.check_list.length)
      ) {
        let medicalNecessity = {
          medical_necessity: {
            check_list: this.covidFluOrderInformation.check_list || [],
            others: this.covidFluOrderInformation.others || "",
          },
          case_type: "COVID_FLU",
        };
        medicalNecessities.push(medicalNecessity);
      } else {
        if (
          this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("COVID_FLU") > -1
        ) {
          let medicalNecessity = {
            medical_necessity: {},
            case_type: "COVID_FLU",
          };
          medicalNecessities.push(medicalNecessity);
        }
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("COVID") > -1 &&
        (this.covidOrderInformation.others ||
          this.covidOrderInformation.check_list.length)
      ) {
        let medicalNecessity = {
          medical_necessity: {
            check_list: this.covidOrderInformation.check_list || [],
            others: this.covidOrderInformation.others || "",
          },
          case_type: "COVID",
        };
        medicalNecessities.push(medicalNecessity);
      } else {
        if (
          this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("COVID") > -1
        ) {
          let medicalNecessity = {
            medical_necessity: {},
            case_type: "COVID",
          };
          medicalNecessities.push(medicalNecessity);
        }
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("RESPIRATORY_PATHOGEN_PANEL") >
          -1 &&
        (this.rppOrderInformation.others ||
          this.rppOrderInformation.check_list.length)
      ) {
        let medicalNecessity = {
          medical_necessity: {
            check_list: this.rppOrderInformation.check_list || [],
            others: this.rppOrderInformation.others || "",
          },
          case_type: "RESPIRATORY_PATHOGEN_PANEL",
        };
        medicalNecessities.push(medicalNecessity);
      } else {
        if (
          this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf(
            "RESPIRATORY_PATHOGEN_PANEL"
          ) > -1
        ) {
          let medicalNecessity = {
            medical_necessity: {},
            case_type: "RESPIRATORY_PATHOGEN_PANEL",
          };
          medicalNecessities.push(medicalNecessity);
        }
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("WOUND") > -1 &&
        (this.woundOrderInformation.others ||
          this.woundOrderInformation.check_list.length)
      ) {
        let medicalNecessity = {
          medical_necessity: {
            check_list: this.woundOrderInformation.check_list || [],
            others: this.woundOrderInformation.others || "",
          },
          case_type: "WOUND",
        };
        medicalNecessities.push(medicalNecessity);
      } else {
        if (
          this.caseInformation &&
          this.caseInformation.case_types &&
          this.caseInformation.case_types.indexOf("WOUND") > -1
        ) {
          let medicalNecessity = {
            medical_necessity: {},
            case_type: "WOUND",
          };
          medicalNecessities.push(medicalNecessity);
        }
      }
      if (medicalNecessities && medicalNecessities.length) {
        params.medical_necessities = medicalNecessities;
      }
      if (
        this.toxicology_ereq_form &&
        this.toxicology_ereq_form.length &&
        this.isToxicCaseType
      ) {
        params.toxicology_ereq_form = this.toxicology_ereq_form;
      } else {
        params.toxicology_ereq_form = [];
      }

      return params;
    },
    parseCaseInfo() {
      return {
        case_types: this.accessionCaseType.length
          ? this.accessionCaseType
          : this.caseInformation.case_types,

        lab: this.caseInformation.lab,

        hospital: this.caseInformation.hospital,
        icd_10_codes: this.caseInformation.icd_10_codesForm
          .filter((e) => e.value)
          .map((e) => e.value),
        ordering_physician: this.caseInformation.ordering_physician,
        referring_physician: this.caseInformation.referring_physician || null,
        hospital_branch: this.caseInformation.hospital_branch
          ? this.caseInformation.hospital_branch
          : null,
        billing_type: this.caseInformation.billing_type,

        additional_fax: this.caseInformation.additional_fax,
        order_id: this.caseInformation.order_id,

        collection_date: this.convertToLabUTC(
          this.caseInformation.collection_date
        ),
        received_date: this.convertToLabUTC(this.caseInformation.received_date),
        temperature: this.caseInformation.temperature,
        sample_types: this.specimenTypes.length
          ? this.convertSampleTypesToCapital(this.specimenTypes)
          : this.convertSampleTypesToCapital(this.caseInformation.sample_types),
      };
    },
    convertSampleTypesToCapital(sampleTypes) {
      if (!sampleTypes) return "";
      return sampleTypes.map((s) => {
        s.sample_types = s.sample_types.map((f) => this.changetocaptila(f));
        return s;
      });
    },
    updateSelectedTabQuery() {
      const primaryInfo = this.$refs["primaryInsuranceForm"];
      if (primaryInfo) {
        this.primaryInsuranceForm = this.parseInsuranceForm(
          primaryInfo.getPrimaryInsuranceFormData()
        );
      }
      const secondaryInfo = this.$refs["secondaryInsuranceForm"];
      if (secondaryInfo) {
        this.secondaryInsuranceForm = this.parseInsuranceForm(
          secondaryInfo.getSecondaryInsuranceFormData()
        );
      }
      const teritaryInfo = this.$refs["tertiaryInsuranceForm"];
      if (teritaryInfo) {
        this.tertiaryInsuranceForm = this.parseInsuranceForm(
          teritaryInfo.getTertiaryInsuranceFormData()
        );
      }
      const gaurantorInfo = this.$refs["guarantorInsuranceForm"];
      if (gaurantorInfo) {
        this.guarantorInsuranceForm = this.parseInsuranceForm(
          gaurantorInfo.getGuarantorInsuranceFormData()
        );
      }
    },

    async setUtiPhysicianData() {
      if (this.isFacilityUser) {
        this.fetchPhysicianDetails();
      }
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        (this.caseInformation.case_types.indexOf("UTI") > -1 ||
          this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1 ||
          this.caseInformation.case_types.indexOf("URINALYSIS") > -1)
      ) {
        if (this.caseInformation && this.caseInformation.ordering_physician) {
          this.utiOrderInformation.name_of_clinician =
            this.getSelectedPhysician(this.caseInformation.ordering_physician)
              .name || "";
          this.utiOrderInformation.clinician_npi =
            this.getSelectedPhysician(this.caseInformation.ordering_physician)
              .npi_code || "";
          this.toxicologyOrderInformation.name_of_clinician =
            this.getSelectedPhysician(this.caseInformation.ordering_physician)
              .name || "";
          this.toxicologyOrderInformation.clinician_npi =
            this.getSelectedPhysician(this.caseInformation.ordering_physician)
              .npi_code || "";
          this.urinalysisOrderInformation.name_of_clinician =
            this.getSelectedPhysician(this.caseInformation.ordering_physician)
              .name || "";
          this.urinalysisOrderInformation.clinician_npi =
            this.getSelectedPhysician(this.caseInformation.ordering_physician)
              .npi_code || "";
        }
      }
    },
    async fetchAllPhysiciansByHospital(hospital) {
      try {
        this.caseInformation.ordering_physician = undefined;
        this.caseInformation.hospital_branch = null;
        this.physician_sign = null;
        let params = {
          hospital,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        if (this.getAllPhysicians) {
          this.physiciansData = JSON.parse(
            JSON.stringify(this.getAllPhysicians)
          );
        }
        await this.$store.dispatch("branches/fetchAllBranches", {
          hospital_id: hospital,
          get_all: true,
        });
        this.hospitalBranches = this.getAllBranches.data;
        if (
          this.caseInformation &&
          this.caseInformation.case_types &&
          (this.caseInformation.case_types.indexOf("UTI") > -1 ||
            this.caseInformation.case_types.indexOf("TOXICOLOGY") > -1 ||
            this.caseInformation.case_types.indexOf("URINALYSIS") > -1)
        ) {
          if (this.caseInformation && this.caseInformation.hospital) {
            this.utiOrderInformation.name_of_practice =
              this.getSelectedHospital(this.caseInformation.hospital);
            this.toxicologyOrderInformation.name_of_practice =
              this.getSelectedHospital(this.caseInformation.hospital);
            this.urinalysisOrderInformation.name_of_practice =
              this.getSelectedHospital(this.caseInformation.hospital);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      try {
        this.caseInformation.ordering_physician = undefined;

        if (hospitalBranch) {
          let params = {
            hospital_branch: hospitalBranch,
            get_all: true,
          };
          await this.$store.dispatch("physicians/fetchAllPhysicians", params);
          this.physiciansData = JSON.parse(
            JSON.stringify(this.getAllPhysicians)
          );
        } else {
          this.fetchAllPhysiciansByHospital(this.caseInformation.hospital);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getAutoCompleteICDData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_code = searchString.trim();
        }

        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        const allIcdCodes = [];
        (this.getAllIcd10Codes.data || []).forEach((el) => {
          allIcdCodes.push({
            value: el.code + " - " + el.description,
            ...el,
          });
        });

        cb(allIcdCodes || []);
      } catch (err) {
        return cb([]);
      }
    },
    selectICDCode(event, icdCodeData) {
      icdCodeData.value = event.code;
      this.previousSearchString = "";
    },

    getLabCaseTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.search_case_types = this.getUserBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },

    updateTestsPanelsData(event) {
      this.show = false;
      this.modalLoading = true;
      const loading = startLoading();

      if (event && event.data) {
        this.panelsTestsData.selectedTestIds = event.data.selectedTestIds;
        this.panelsTestsData.selectedCategories = event.data.selectedCategories;
        this.panelsTestsData.selectedGroup = event.data.selectedGroup;
        this.allTests = event.allTests;
        this.custom_test_profiles = event.customProfile;
      }
      setTimeout(() => {
        this.addtestModelPopup = false;
        this.show = true;
        loading.close();
      }, 500);
    },
    getSelectedCaseTypes() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length
      ) {
        let data = this.panelsTestsData.selectedCategories
        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },

    async checkCaseInformation() {
      try {
        this.loading = true;
        this.phlebioId = this.$route.params.phlebio_id;
        await this.fetchHospitalsData();
        await this.fetchAllPhysiciansByHospital(
          this.getPhlebioInfo.hospital._id
        );
        if (this.getPhlebioInfo && this.getPhlebioInfo.referring_physician) {
          await this.fetchPhysiciansData();
        }

        if (this.getPhlebioInfo) {
          if (this.getPhlebioInfo.patient_info) {
            this.showDob = true;

            this.patientInformation = {
              ...this.getPhlebioInfo.patient_info,
            };
          }
          if (this.getPhlebioInfo.toxicology_order_medical_necessity_fields) {
            this.toxicologyOrderInformation =
              this.getPhlebioInfo.toxicology_order_medical_necessity_fields;
          }
          if (
            this.getPhlebioInfo
              .urinary_tract_infectious_medical_necessity_fields
          ) {
            this.utiOrderInformation.patient_name =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.patient_name;
            this.utiOrderInformation.check_list =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.check_list;
            this.utiOrderInformation.patient_dob =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.patient_dob;
            this.utiOrderInformation.date_of_service =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.date_of_service;
            this.utiOrderInformation.icd_codes =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.icd_codes;
            this.utiOrderInformation.icd_codes.forEach((el, index) => {
              this.caseInformation.icd_10_codesForm[index].value = el;
            });
            this.utiOrderInformation.others =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.others;
            this.utiOrderInformation.name_of_practice =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.name_of_practice;
            this.utiOrderInformation.name_of_clinician =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.name_of_clinician;
            this.utiOrderInformation.clinician_npi =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.clinician_npi;
            this.utiOrderInformation.ordering_clinician_signature =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.ordering_clinician_signature;
            this.utiOrderInformation.date =
              this.getPhlebioInfo.urinary_tract_infectious_medical_necessity_fields.date;
          }
          if (this.getPhlebioInfo.urinalysis_order_medical_necessity_fields) {
            this.urinalysisOrderInformation =
              this.getPhlebioInfo.urinalysis_order_medical_necessity_fields;
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.medical_necessities &&
            this.getPhlebioInfo.medical_necessities.length
          ) {
            for (
              let i = 0;
              i < this.getPhlebioInfo.medical_necessities.length;
              i++
            ) {
              if (
                this.getPhlebioInfo.medical_necessities[i].case_type == "GASTRO"
              ) {
                this.gastroOrderInformation =
                  this.getPhlebioInfo.medical_necessities[i].medical_necessity;
              } else if (
                this.getPhlebioInfo.medical_necessities[i].case_type ==
                "COVID_FLU"
              ) {
                this.covidFluOrderInformation =
                  this.getPhlebioInfo.medical_necessities[i].medical_necessity;
              } else if (
                this.getPhlebioInfo.medical_necessities[i].case_type == "COVID"
              ) {
                this.covidOrderInformation =
                  this.getPhlebioInfo.medical_necessities[i].medical_necessity;
              } else if (
                this.getPhlebioInfo.medical_necessities[i].case_type ==
                "RESPIRATORY_PATHOGEN_PANEL"
              ) {
                this.rppOrderInformation =
                  this.getPhlebioInfo.medical_necessities[i].medical_necessity;
              } else if (
                this.getPhlebioInfo.medical_necessities[i].case_type == "WOUND"
              ) {
                this.woundOrderInformation =
                  this.getPhlebioInfo.medical_necessities[i].medical_necessity;
              } else if (
                this.getPhlebioInfo.medical_necessities[i].case_type == "NAIL"
              ) {
                this.nailOrderInformation =
                  this.getPhlebioInfo.medical_necessities[i].medical_necessity;
              }
            }
          }

          this.setCaseInformationData();
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.case_types &&
            this.getPhlebioInfo.case_types.includes("TOXICOLOGY")
          ) {
            if (
              this.getPhlebioInfo &&
              this.getPhlebioInfo.sample_types &&
              this.getPhlebioInfo.sample_types.length
            ) {
              for (
                let i = 0;
                i < this.getPhlebioInfo.sample_types.length;
                i++
              ) {
                for (
                  let j = 0;
                  j < this.getPhlebioInfo.sample_types[i].sample_types.length;
                  j++
                ) {
                  let sampleTypeData =
                    this.getPhlebioInfo.sample_types[i].sample_types[j];
                  if (sampleTypeData.includes("Oral")) {
                    let sample = ["Oral"];
                    this.setShowChecklist(sample);
                  }
                  if (sampleTypeData.includes("Urine")) {
                    let sample = ["Urine"];
                    this.setShowChecklist(sample);
                  }
                }
              }
            }
          }
          if (this.getPhlebioInfo && this.getPhlebioInfo.physician_notes) {
            this.physician_notes = this.getPhlebioInfo.physician_notes;
          }
          if (this.getPhlebioInfo && this.getPhlebioInfo.signature_settings) {
            this.signatureInformation = this.getPhlebioInfo.signature_settings;
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.signature_settings &&
            this.getPhlebioInfo.signature_settings.patient_sign
          ) {
            this.patient_sign =
              this.getPhlebioInfo.signature_settings.patient_sign;
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.signature_settings &&
            this.getPhlebioInfo.signature_settings.physician_sign
          ) {
            this.physician_sign =
              this.getPhlebioInfo.signature_settings.physician_sign;
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.signature_settings &&
            this.getPhlebioInfo.signature_settings.guardian_sign
          ) {
            this.guardian_sign =
              this.getPhlebioInfo.signature_settings.guardian_sign;
          }
          if (this.getPhlebioInfo && this.getPhlebioInfo.tests_info) {
            this.panelsTestsData.selectedTestIds =
              this.getPhlebioInfo.tests_info.map((el) => el._id);
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.case_types &&
            this.getPhlebioInfo.case_types.length &&
            this.getPhlebioInfo.case_types.length == 1 &&
            this.getPhlebioInfo.sample_types
          ) {
            this.caseInformation.sample_types =
              this.getPhlebioInfo.sample_types;
          }
          if (
            this.getPhlebioInfo.coriell_test_panels &&
            this.getPhlebioInfo.coriell_test_panels.length
          ) {
            this.panelsTestsData.selectedCoriellPanels =
              this.getPhlebioInfo.coriell_test_panels;
          }

          this.allTests = this.getPhlebioInfo.tests_info;
          if (this.getPhlebioInfo.custom_test_profiles) {
            this.custom_test_profiles =
              this.getPhlebioInfo.custom_test_profiles.map((el) => el._id);
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.billing_info &&
            this.getPhlebioInfo.billing_info.insurance &&
            this.getPhlebioInfo.billing_info.insurance.primary_insurance
          ) {
            this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getPhlebioInfo.billing_info.insurance.primary_insurance
            );
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.billing_info &&
            this.getPhlebioInfo.billing_info.insurance &&
            this.getPhlebioInfo.billing_info.insurance.secondary_insurance
          ) {
            this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getPhlebioInfo.billing_info.insurance.secondary_insurance
            );
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.billing_info &&
            this.getPhlebioInfo.billing_info.insurance &&
            this.getPhlebioInfo.billing_info.insurance.tertiary_insurance
          ) {
            this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getPhlebioInfo.billing_info.insurance.tertiary_insurance
            );
          }
          if (
            this.getPhlebioInfo &&
            this.getPhlebioInfo.billing_info &&
            this.getPhlebioInfo.billing_info.insurance &&
            this.getPhlebioInfo.billing_info.insurance.guarantor
          ) {
            this.guarantorInsuranceForm =
              this.getPhlebioInfo.billing_info.insurance.guarantor;
          }
        }
        this.toxicology_ereq_form = this.getPhlebioInfo.toxicology_ereq_form
          ? this.getPhlebioInfo.toxicology_ereq_form
          : [];

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    setCaseInformationData() {
      if (
        this.getPhlebioInfo &&
        Object.keys(this.getPhlebioInfo) &&
        Object.keys(this.getPhlebioInfo).length
      ) {
        this.caseInformation.case_types = this.getPhlebioInfo.case_types;
        this.caseInformation.lab = this.getUserPrimaryLabId
          ? this.getUserPrimaryLabId
          : null;

        if (this.getPhlebioInfo.collection_date) {
          this.caseInformation.collection_date = this.convertLabUTCToClient(
            this.getPhlebioInfo.collection_date
          );
        }
        if (this.getPhlebioInfo.received_date) {
          this.caseInformation.received_date = this.convertLabUTCToClient(
            this.getPhlebioInfo.received_date
          );
        }
        this.caseInformation.temperature = this.getPhlebioInfo.temperature
          ? this.getPhlebioInfo.temperature
          : null;
        this.caseInformation.hospital = this.getPhlebioInfo.hospital
          ? this.getPhlebioInfo.hospital._id
          : null;
        this.caseInformation.ordering_physician =
          this.getPhlebioInfo.ordering_physician._id;
        this.caseInformation.order_id = this.getPhlebioInfo.order_id;

        this.caseInformation.referring_physician =
          this.getPhlebioInfo.referring_physician &&
          this.getPhlebioInfo.referring_physician._id
            ? this.getPhlebioInfo.referring_physician._id
            : null;
        this.caseInformation.hospital_branch = this.getPhlebioInfo
          .hospital_branch
          ? this.getPhlebioInfo.hospital_branch._id
          : null;
        this.caseInformation.icd_10_codes = this.getPhlebioInfo.icd_10_codes;
        this.caseInformation.billing_type = this.getPhlebioInfo.billing_type;

        this.caseInformation.requisition_order_id =
          this.getPhlebioInfo.requisition_order_id || "";

        this.caseInformation.patient_info = this.getPhlebioInfo.patient_info;

        this.caseInformation.icd_10_codes.forEach((el, index) => {
          this.caseInformation.icd_10_codesForm[index].value = el;
        });

        this.caseInformation.additional_fax =
          this.getPhlebioInfo.additional_fax &&
          this.getPhlebioInfo.additional_fax.length
            ? this.getPhlebioInfo.additional_fax
            : [];
        if (
          this.getPhlebioInfo &&
          (this.getPhlebioInfo.is_fasting == false ||
            this.getPhlebioInfo.is_fasting == true)
        ) {
          this.caseInformation.is_fasting = this.getPhlebioInfo.is_fasting;
        }
      }
    },
    clearGuardianSign() {
      this.guardian_sign = "";
    },
    clearPhysicinaSign() {
      this.physician_sign = "";
    },
    clearPatientSign() {
      this.patient_sign = "";
    },
  },
  watch: {
    "caseInformation.case_types": {
      immediate: true,
      handler: function () {
        this.setToxicMedicalNecessity();
        this.hideTestsDetails = true;
        setTimeout(() => {
          this.hideTestsDetails = false;
        }, 1000);
      },
    },
  },
};
</script>

<style lang="scss">
.signature-settings {
  .case-creation__body {
    padding-bottom: 10px !important;
  }

  .el-checkbox {
    height: auto;
    margin-right: 10px;
    margin-bottom: -4px;
  }

  label {
    span {
      color: #f24a55;
      text-transform: uppercase;
    }
  }
}
.type_signature {
  display: grid;
  grid-template-columns: 0.8fr 1fr;
  column-gap: 20px;
  .signature-fields {
    .el-input {
      width: 100% !important;
    }
    .el-select {
      margin-bottom: 0.5rem;
    }
    .select-trigger {
      margin-bottom: 0.5rem;
    }
    .el-input__inner {
      background: #ffffff;
      padding-right: 25px !important;
      padding-left: 5px;
      color: #000;
      border: 0.922417px solid rgba(156, 156, 156, 0.5);
      font-weight: 500;
      font-size: 13px;
      box-sizing: border-box;
      border-radius: 3.56227px;
      height: 30px !important;
    }
  }
}
.signature {
  width: 95% !important;
  #myCanvas {
    border: none !important;
    height: 100%;
    object-fit: contain;
    width: 100%;
  }
}

.signature {
  background-color: #fff;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  box-sizing: border-box;
  width: 90%;
  margin: auto;
  height: 125px;
  text-align: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  #myCanvas {
    border: none !important;
    height: 100%;
    width: 100%;
  }
}
.signature-after-sign {
  img {
    width: 250px;
    height: 100px;
    padding: 1rem 0;
  }
}
.patient-popup {
  .attach-img {
    text-align: center;
    width: 100%;
    img {
      width: 150px;
    }
  }
  .attach-input {
    text-align: center;
    margin: 10px 0;
    width: 100%;
    padding: 5px 10px;
    background: none;
    position: relative;
    color: #fff;
    border-radius: 2px;
    text-align: center;
    float: left;
    cursor: pointer;
    .hide_file {
      position: absolute;
      z-index: 1000;
      opacity: 0;
      cursor: pointer;
      right: 0;
      top: 0;
      height: 100%;
      font-size: 24px;
      width: 100%;
    }
  }

  .el-tabs__item {
    color: #828282;
    font-weight: 500;
    text-transform: uppercase;
    padding: 0px 40px 0 0 !important;
  }

  .el-tabs__item.is-active {
    color: #0a5da6 !important;
    font-weight: 500;
  }

  .el-tabs__active-bar {
    background-color: #0a5da6 !important;
  }
}
.uti-medical-necessity {
  .heading-block {
    margin-bottom: 10px;
  }

  h3 {
    font-size: 1em;
    color: #0a5da6;
    margin-bottom: 5px;
    border-left: 5px solid #0a5da6;
    padding-left: 5px;
  }

  h4 {
    font-size: 0.9em;
  }

  p {
    font-size: 0.9em;
    line-height: 20px;
  }

  .text-check-box {
    display: flex;
  }

  .el-checkbox {
    height: 25px;
    font-size: 13px;
  }

  label {
    margin-bottom: 5px;
  }

  .el-checkbox__input {
    background: #ffffff;
    border: 1.27979px solid #9c9c9c;
    box-sizing: border-box;
    border-radius: 3.83936px;
  }

  .el-checkbox__inner {
    border-radius: 2.55957px;
    margin: 1px;
    width: 13px;
    height: 13px;
    border: none;
  }

  .el-checkbox-group .el-checkbox__label {
    color: #34495e;
  }

  .el-checkbox__inner::after {
    content: "";
    border: 1.6px solid var(--el-checkbox-checked-icon-color);
    border-left: 0;
    border-top: 0;
    height: 6px;
    left: 4px;
    position: absolute;
    top: 1px;
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    transition: transform 0.15s ease-in 50ms;
    transform-origin: center;
  }

  .el-checkbox__input .el-checkbox__inner {
    border-color: transparent;
    box-shadow: 0 0 0 1px transparent;
    border-radius: 4px;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #0a5da6;
    border-color: #ffffff;
    box-shadow: 0 0 0 1px #ced1d6;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: rotate(45deg) scaleY(1);
  }
}
.active-case-type-error {
  margin-top: 25px !important;
}
//Addtional Fax start
.vue-form {
  .mobile-icon {
    position: relative;

    .el-icon {
      position: absolute;
      right: 2%;
      top: 38%;
      opacity: 0.3;
    }
  }

  .additonal-fax {
    display: flex;
    gap: 20px;
  }
}
//Addtional Fax end
//Look Popup start
.empty-test-inner {
  margin-top: 5em;
  margin-bottom: 5em;
  text-align: center;

  .test-info {
    margin: 0 auto;

    img {
      width: 115px;
      margin: 10px;
    }
  }

  .content {
    text-align: center;

    p {
      color: #828282;
      line-height: 22px;
      font-size: 14px;
    }

    .el-button {
      margin: 14px 0;

      background: #0a5da6 !important;
      box-shadow: 0px 8px 16px -4px rgba(16, 38, 137, 0.1);
      border-radius: 10px;
      color: #fff;
      border: 0.7px solid #0a5da6;
    }
  }
}
//Look Popup End
//medication remove start
.lists {
  margin: 0;
  display: flex;
  justify-content: flex-start;

  .remove-btn {
    .el-button {
      border: none;
      padding: 0;
      min-height: 20px;

      &:hover {
        background: none;
      }

      &:active {
        background: none;
      }

      &:focus {
        background: none;
      }
    }

    .el-dialog--center {
      border-radius: 5px;

      .el-dialog__body {
        text-align: initial;
        padding: 17px calc(var(--el-dialog-padding-primary) + 25px) 10px;
        text-align: center;

        span {
          img {
            vertical-align: top;
          }

          .view-cases {
            color: #0a5da6;
          }
        }
      }

      .el-dialog__footer {
        .dialog-footer {
          .el-button {
            border: 1.3px solid #dedbdb;
            color: #4f4f4f;
            padding: 5px;
            border-radius: 5px;

            &:hover {
              background-color: #f24a55;
              color: #fff;
            }
          }

          .el-button--primary {
            background: none;
            padding: 5px 20px;

            &:hover {
              background-color: #215fad;
              color: #fff;
            }
          }
        }
      }
    }

    .el-dialog__header {
      display: none;
    }
  }
}
.active-tabs {
  color: #eb5757;
  font-weight: 500;
}
.undo-btn {
  width: 80%;
  margin: auto;
  text-align: center;
  .clear-btn {
    background: #ffffff;
    box-shadow: 0px 8px 16px -4px rgba(16, 38, 137, 0.1);
    padding: 0 1em;
    color: #eb5757;
    height: 30px;
    width: 80px;
    text-align: center;
    min-height: 30px;
    border-radius: 5px;
  }
}
.el-icon {
  cursor: pointer;
}
//medication remove end
</style>
